/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withRouter } from 'react-router';
import {
    object, string, bool, func, shape, arrayOf, array, number,
} from 'prop-types';
import {
    format,
    addDays,
    startOfMonth,
    isSameMonth,
    compareAsc,
} from 'date-fns';
import mbpLogger from '@module-logger/mbp';
import {
    Paper,
    TextField,
    Select,
    InputLabel,
    MenuItem,
    Typography,
    FormControl,
    NativeSelect,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import getDeliveryCalendarByProduct from '../../../../../apis/product-apis/getDeliveryCalendarByProduct';
import availablityDeliveryCalendar from '../../../../../apis/cart-service-apis/availablityDeliveryCalendar';
import DeliveryCalendarButtonContainer from './DeliveryCalendarButtonContainer';
import GraphqlCalendarContainer from './GraphqlPDPCalendar/GraphqlCalendarContainer';
import GraphqlPortalLoader from '../../GraphqlCommonComponents/GraphqlPortalLoader';
import ConnectedProductAgeVerificationModal from './ProductAgeVerificationModal';
import GraphqlProductNotAvailableModal from './GraphqlProductNotAvailableModal';
import OneClickPaymentBuilder from './OneClickPayments/OneClickPaymentBuilder';
import FlexModal from './GraphqlPDPCalendar/Partials/FlexModal';
import FlexibleShippingOptions from './GraphqlPDPCalendar/Partials/FlexibleShippingOptions';
import { actions as tagManagerActions } from '../../../../../state/ducks/TagManager';
import { getCountryCodeByCategoryPath } from '../../../../../state/ducks/Checkout/helpers/countryCode';
import { filterInternationalCountry } from '../../../../../state/ducks/Checkout/ducks/Checkout/Checkout-Helper';
import { checkDateHasBackUpProduct } from '../../../../helpers/checkFptGptProductBackUp';
import PersonalizationModal from './PersonalizationModal';
import customBreakpoints from '../../../../helpers/customBreakpoints';
import { isVaseConfigProduct } from '../../../../helpers/vaseConfigurations';
import { getPassportSubscriptionStatus } from '../../../../../state/ducks/Passport/Passport-Selectors';

import { withAuth } from '../../../../../state/ducks/Member/ducks/Auth/Plugin/auth';

import {
    setLocationType,
    validateProductFilterZipcode,
    clearValidatedZipcode,
    resetProductFilterZipcodeValidity,
    setUserSubmittedProductFilterZipcode,
    clearUserSubmittedProductFilterZipcode,
    clearUserSelectedAddress,
    setUserSelectedAddress,
    setProductFilterZipcodeValidity,
    setValidatedZipcode,
    verifyWine,
} from '../../../../../state/ducks/App/App-Actions';
import {
    getLocationType,
    getValidatedZipcode,
    getIsProductFilterZipcodeValid,
    getUserSubmittedProductFilterZipcode,
    getSavedAddress,
    getWineData,
    getSubscriptionFrequencyData,
    getSSRDeviceType,
    getPageType,
} from '../../../../../state/ducks/App/App-Selectors';
import { getFeatureFlag } from '../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { getActiveABTests } from '../../../../../state/ducks/App/ducks/ABTesting/ABTesting-Selectors';
import memberDucks from '../../../../../state/ducks/Member/ducks';
import { getBrand } from '../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import { getIsAuthenticatedStatus, getIsWriteScopeCheckout, getProfileInfo } from '../../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import { getZipByAddressSource } from '../../../../../state/ducks/AddToCart/helpers/preCheckoutAddressNormalizer';
import AddressBookWithPagination from '../../../../pages/Checkout/containers/CheckoutFloral/Partials/AddressBookWidget/AddressBookWithPagination';
import DesktopMobile from '../../../../helpers/DesktopMobile/DesktopMobile';
import { addToCartNewCartServices } from '../../../../../state/ducks/AddToCart/AddToCart-Actions';
import VaseConfigATCError from './GraphqlPDPSkus/VaseConfigurator/VaseConfigATCError';
import LimitedAccessReSignInLink from './LimitedAccessReSignInLink';
import { getBaseCode } from '../../../../helpers/tracking/product/dataLayerProductHelpers';
import AddToCartBuilderObject from './GraphqlFoodAddToCart/Partials/AddToCartBuilderObject';
import { formatDate_MM_dd_yyyy_HH_mm_ss } from './GraphqlPDPCalendar/Partials/Helper/helper';
import isProductListingAd from '../../../../helpers/isProductListingAd';
import AddToCarErrorInline from '../AddToCartErrorInline';
import KlarnaCreditPromotionBadge from '../../../Checkout/KlarnaPaymentOnSiteMessage/KlarnaCreditPromotionBadge/KlarnaCreditPromotionBadge';
import PDPAddonContainer from './StandardProductsPage/variants/PDPAddon/PDPAddonContainer';
import PDPAddonMessage from './StandardProductsPage/variants/PDPAddon/PDPAddonMessage';
import TalonOneBanner from './TalonOne/talonOneBanner';
import LoadCardIslePDP from '../../../vendors/CardIsle/LoadCardIslePDP';
import { emitCustomTrackingEvent } from '../../../../../state/ducks/TagManager/ducks/ClickStreamEvents/ClickStreamEvent-Actions';

const {
    common: {
        commonSelectors: {
            getAddressBookEntries,
            getAddressBookPageNumber,
            getTotalNoOfPages,
            getTotalEntriesAddressBook,
            getUserType,
            getIsPassportUserLoggedIn,
        },
    },
    addressBook: {
        addressBookActions: {
            loadAddressBook,
            removeAddressBook,
        },
    },
} = memberDucks;

const ENTER_KEY = 13;

const styles = (theme) => ({
    root: {
        marginBottom: '20px',
        width: '100%',
        color: '#000',
        [theme.breakpoints.down('sm')]: {
            marginBottom: '10px',
        },
    },
    selectLabel: {
        display: 'block',
    },
    formContainer: {
        display: 'flex',
        [theme.breakpoints.down('sm')]: {
            marginBottom: '20px',
        },
    },
    formWrapper: {
        position: 'relative',
        width: '50%',
        '&:after': {
            content: '""',
            position: 'absolute',
            top: '18px',
            right: '4px',
            width: '1px',
            height: '45px',
            borderLeft: '1px solid #949494', // Todo: add greys to brand palette
            [theme.breakpoints.down('sm')]: {
                top: '5px',
            },
        },
    },
    formWrapperV2: {
        position: 'relative',
        width: '50%',
        '& .MuiInput-underline': {
            '&:before': {
                borderBottom: 'none',
            },
        },
        '&:after': {
            content: '""',
            position: 'absolute',
            top: '18px',
            right: '4px',
            width: '1px',
            height: '45px',
            [theme.breakpoints.down('sm')]: {
                top: '5px',
            },
        },
        '& .MuiInputLabel-shrink': {
            top: '.05px !important',
        },
        '& .MuiFormLabel-root.Mui-focused': {
            top: '0px',
            borderBottom: 'none',
        },
    },
    zipCodeInput: {
        width: '100%',
        background: 'none',
        display: 'block',  // IE 11
        [theme.breakpoints.down('sm')]: {
            margin: '0px',
            zIndex: 1,
        },
        '& > div': {
            width: '100%', // IE 11
        },
        '& > label': {
            [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                fontSize: 16,
            },
        },
    },
    zipCodeInputV2: {
        width: '95%',
        background: 'none',
        display: 'block',  // IE 11
        height: '54px',
        [theme.breakpoints.down('sm')]: {
            margin: '0px',
            zIndex: 1,
            border: '1px solid #C4C4C4',
            borderRadius: '3px',
        },
        '& > div': {
            width: '100%',
            paddingLeft: '8px', // IE 11
        },
        '& > label': {
            fontFamily: 'museo-sans, "Area Variable", Helvetica',
            paddingLeft: '10px',
            paddingTop: '5px',
            // fontSize: '12px',
            fontWeight: 400,
            lineHeight: '18px',
            letterSpacing: '0.01em',
            color: '#555555',
            top: '-13px',
            fontSize: '16px !important',
            [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                fontSize: 16,
                top: '-13px',
                fontFamily: 'museo-sans, "Area Variable", Helvetica',
                '& .MuiFormLabel-root.Mui-focused': {
                    top: '0px',
                },
            },
        },
    },
    zipCodeInputValid: {
        '&::after': {
            position: 'absolute',
            zIndex: '99',
            backgroundColor: theme.palette.colorSuccess,
            color: theme.palette.white,
            textAlign: 'center',
            content: '"✓"',
            fontSize: '9px',
            fontWeight: 'bold',
            lineHeight: '17px',
            left: '130px',
            width: '15px',
            height: '15px',
            borderRadius: '50%',
            animation: 'fadeZoomIn 0.3s ease-in',
            display: 'inline-block', // IE 11
            [theme.breakpoints.down(600)]: {
                left: '120px',
            },
        },
    },
    zipCodeInputValidV2: {
        '&::after': {
            top: '4px',
            position: 'absolute',
            zIndex: '999',
            backgroundColor: theme?.palette?.primaryButton,
            color: theme.palette.white,
            textAlign: 'center',
            content: '"✓"',
            fontSize: '9px',
            fontWeight: 'bold',
            lineHeight: '17px',
            left: '75px',
            width: '15px',
            height: '15px',
            borderRadius: '50%',
            animation: 'fadeZoomIn 0.3s ease-in',
            display: 'inline-block', // IE 11
            [theme.breakpoints.down(600)]: {
                left: '120px',
            },
            [theme.breakpoints.down(415)]: {
                left: '70px',
            },
        },
    },
    zipCodeInputInvalid: {
        position: 'relative',
        '&::before': {
            position: 'absolute',
            zIndex: '999',
            color: theme.palette.cms?.white || '#fff',
            lineHeight: '25px',
            fontSize: '11px',
            fontWeight: '300',
            content: '"Invalid zip code"',
            bottom: '-25px',
            left: 0,
            paddingLeft: '7px',
            width: 'calc(100% - 8px)',
            height: '25px',
            backgroundColor: theme.palette.cms?.red || '#ff0000',
            transition: 'opacity 0.3s ease-in',
            opacity: 1,
        },
    },
    addToCartZipCheck: {
        position: 'relative',
        '&::before': {
            position: 'absolute',
            zIndex: '999',
            color: theme.palette.cms?.white || '#fff',
            lineHeight: '25px',
            fontSize: '11px',
            fontWeight: '300',
            content: '"Enter a 5 digit zip code"',
            bottom: '-25px',
            left: 0,
            paddingLeft: '7px',
            width: 'calc(100% - 8px)',
            height: '25px',
            backgroundColor: theme.palette.cms?.red || '#ff0000',
            transition: 'opacity 0.3s ease-in',
            opacity: 1,
            [theme.breakpoints.down('sm')]: {
                lineHeight: '18px',
                bottom: '-18px',
                width: 'calc(100% - 4px)',
                height: '20px',
            },
        },
    },
    locationWrapper: {
        width: '50%',
        marginTop: '14.5px',
        marginBottom: '26px',
        [theme.breakpoints.down('sm')]: {
            margin: '0px',
        },
    },
    locationWrapperV2: {
        width: '50%',
        marginTop: '14.5px',
        marginBottom: '26px',
        marginLeft: '5px',
        border: '1px solid #C4C4C4',
        borderRadius: '3px',
        paddingLeft: '8px',
        [theme.breakpoints.down('sm')]: {
            margin: '0px',
        },
        '& .MuiInput-underline': {
            '&:before': {
                borderBottom: 'none',
            },
            '&:after': {
                borderBottom: 'none',
            },
        },
    },
    locationTypeLabel: {
        display: 'block',
        width: '100%',
        fontSize: '18px',
        [theme.breakpoints.down('sm')]: {
            fontSize: 16,
        },
    },
    locationTypeLabelV2: {
        display: 'block',
        width: '100%',
        fontSize: '18px',
        paddingTop: '4px',
        [theme.breakpoints.down('sm')]: {
            fontSize: 16,
        },
    },
    locationTypeSelector: {
        width: '100%',
    },
    locationTypeSelectorV2: {
        width: '100%',
        '& .MuiInputBase-input': {
            padding: '4px 0px 5px',
        },
    },
    paperHeaderLink: {
        color: theme.palette.cms?.primary || '#5F3C86',
        cursor: 'pointer',
    },
    paperHeaderLinkV2: {
        fontFamily: 'Poppins',
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '20px',
        letterSpacing: '0.02em',
        color: theme.palette.cms?.primary || '#5F3C86',
        cursor: 'pointer',
        textDecoration: 'underline',
        [theme.breakpoints.down(391)]: {
            fontSize: '13px',
        },
        [theme.breakpoints.down(376)]: {
            fontSize: '12px',
        },
        [theme.breakpoints.down(354)]: {
            fontSize: '11.5px',
        },
    },
    paperHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
        width: '100%',
        height: '40px',
        padding: '0 20px',
        fontWeight: '600',
        fontSize: '13px',
        lineHeight: '16px',
        background: theme.palette.grey9,
        borderRadius: '4px 4px 0 0',
        [theme.breakpoints.down(768)]: {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gridTemplateRows: '1fr',
            '& div:last-child': {
                display: 'flex',
                justifyContent: 'end',
            },
        },
    },
    paperHeaderV2: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
        width: '100%',
        height: '40px',
        padding: '0 20px',
        fontWeight: '600',
        fontSize: '13px',
        lineHeight: '16px',
        background: '#ECF9F9',
        borderRadius: '4px 4px 0 0',
        [theme.breakpoints.down(768)]: {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gridTemplateRows: '1fr',
            '& div:last-child': {
                display: 'flex',
                justifyContent: 'end',
            },
        },
    },
    pdpDelivery: {
        [theme.breakpoints.down(768)]: {
            paddingRight: '5px',
        },
    },
    pdpDeliveryV2: {
        fontFamily: 'Poppins',
        fontSize: '14px',
        fontWeight: 700,
        lineHeight: '26px',
        letterSpacing: '0.03em',
        [theme.breakpoints.down(768)]: {
            paddingRight: '5px',
        },
        [theme.breakpoints.down(391)]: {
            fontSize: '13px',
        },
        [theme.breakpoints.down(376)]: {
            fontSize: '12px',
        },
        [theme.breakpoints.down(354)]: {
            fontSize: '11.5px',
        },
    },
    paperHeaderPla: {
        '@media screen and (max-width: 1280px) and (min-width: 1026px)': {
            display: 'block',
            height: '53px',
            padding: '10px 13px',
        },
    },

    paperBody: {
        boxSizing: 'border-box',
        padding: '13px 20px 20px 20px',
    },
    buttonCalendarInvalidZip: {
        background: 'grey',
    },
    buttonDivider: {
        margin: '10px 0',
        width: '100%',
        textAlign: 'center',
    },
    buttonBuyNow: {
        width: '100%',
        height: '40px',
        color: 'white',
        textAlign: 'center',
        lineHeight: '40px',
        background: '#000',
        borderRadius: '4px',
        cursor: 'pointer',
    },
    buttonAddToCart: {
        marginTop: '5px',
        width: '100%',
        height: '40px',
        color: 'white',
        textAlign: 'center',
        lineHeight: '40px',
        background: '#2ac670',
        borderRadius: '4px',
        cursor: 'pointer',
    },
    containerPosition: {
        marginTop: '-25px',
        [theme.breakpoints.down(1100)]: {
            marginTop: '15px',
        },
        [theme.breakpoints.down(600)]: {
            marginTop: '0px',
        },
    },
    labelPay: {
        fontSize: '14px',
        lineHeight: '20px',
        '& svg': {
            display: 'inline-block',
            width: '15px',
            height: '15px',
            [theme.breakpoints.down(600)]: {
                marginTop: '13px',
            },
        },
        '& > span': {
            display: 'inline-block',
            width: 'calc(100% - 42px)',
            verticalAlign: 'top',
            margin: '10px 3px',
        },
        '& span > span': {
            fontWeight: 'bold',
        },
    },
    '@keyframes stroke': {
        '100%': {
            strokeDashoffset: '0',
        },
    },
    '@keyframes scale': {
        '0%, 100%': {
            transform: 'none',
        },
        '50%': {
            transform: 'scale3d(1.1, 1.1, 1)',
        },
    },
    '@keyframes fill': {
        '100%': {
            boxShadow: `inset 0px 0px 0px 40px ${theme?.palette?.primaryButton}`,
        },
    },
    checkmarkCircle: {
        strokeDasharray: '166',
        strokeDashoffset: '166',
        strokeWidth: '2',
        strokeMiterlimit: '10',
        stroke: theme?.palette?.primaryButton,
        fill: 'none',
    },
    checkMarkContainer: {
        top: '8px',
        position: 'absolute',
        zIndex: '999',
        color: theme.palette.white,
        textAlign: 'center',
        fontSize: '9px',
        fontWeight: 'bold',
        lineHeight: '17px',
        left: '75px',
        width: '15px',
        height: '15px',
        borderRadius: '50%',
        display: 'inline-block', // IE 11
        [theme.breakpoints.down(600)]: {
            top: '-8px',
            zIndex: 0,
        },
    },
    checkmark: {
        width: '30px',
        height: '30px',
        borderRadius: '50%',
        display: 'inline-block',
        strokeWidth: 4,
        stroke: theme?.palette?.white,
        strokeMiterlimit: '10',
        marginRight: 8,
        verticalAlign: 'middle',
        boxShadow: `inset 0px 0px 0px ${theme?.palette?.primaryButton}`,
        animation: '$fill .4s ease-in-out .4s forwards, $scale .3s ease-in-out .9s both',

        [theme.breakpoints.down('600')]: {
            width: '24px',
            height: '24px',
        },
    },
    checkmarkCheck: {
        transformOrigin: '50% 50%',
        strokeDasharray: '38',
        strokeDashoffset: '5',
    },
    newProductUI: {
        '& $root': {
            boxShadow: 'none',
            [theme.breakpoints.down('880')]: {
                marginTop: '16px',
            },
        },
        '& $paperBody': {
            padding: '20px 16px',
        },
        '& $formContainer': {
            display: 'block',
        },
        '& $formWrapper , $formWrapperV2': {
            width: '100%',
            '&:after': {
                content: 'inherit',
            },
        },
        '& $zipCodeInputInvalid , $addToCartZipCheck': {
            '& > label': {
                color: '#ff0000',
            },
            '& input': {
                border: '1px solid #ff0000',
            },
            '&:before': {
                width: 'calc(100% - 10px)',
            },
            [theme.breakpoints.down('880')]: {
                '&:before': {
                    lineHeight: '15px',
                    height: '16px',
                    bottom: '-7px',
                    fontSize: '12px',
                    width: '100%',
                },
            },
        },
        '& $locationWrapper': {
            width: '100%',
            marginTop: '20px',
            marginBottom: '0px',
            '& .MuiFormControl-root': {
                width: '100%',
            },
        },
        '& $zipCodeInput , $zipCodeInputV2': {
            '& input': {
                border: '1px solid #C4C4C4',
                borderRadius: '3px',
                padding: '23.3px 12px 9px',
            },
            [theme.breakpoints.up('880')]: {
                paddingRight: '10px',
                '& input': {
                    padding: '23.5px 12px 9px',
                },
            },
            '& [class*="shrink"]': {
                top: 15,
                fontSize: '12px',
                lineHeight: '18px',
                [theme.breakpoints.up('880')]: {
                    transform: 'translate(14px, -6px) scale(0.75)',
                },
            },
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'transparent',
            },
            '& > label': {
                lineHeight: '26px',
                color: '#555555',
                fontSize: '16px',
                [theme.breakpoints.up('880')]: {
                    transform: 'translate(14px, 20px) scale(1)',
                },
            },
        },
        '& .card-isle-right': {
            '@media screen and (min-width:600px) and (max-width: 762px)': {
                width: 'calc(100% - 106px)',
            },
        },
        '& .card-isle-left': {
            '@media screen and (min-width:600px) and (max-width: 762px)': {
                width: '100px',
            },
        },
        '& .card-isle-button': {
            '@media screen and (min-width:600px) and (max-width: 762px)': {
                width: '150px !important',
                fontSize: '13px',
            },
        },
        '& $zipCodeInputV2': {
            width: '100%',
            height: '56px',
            border: '0px !important',
            '& > label': {
                padding: '0px',
                top: '0px',
            },
            '& > div': {
                paddingLeft: '0px',
            },
        },
        '& $formWrapperV2': {
            '& .MuiInputLabel-shrink': {
                top: '15px !important',
                fontSize: '12px !important',
            },
            '& $zipCodeInputInvalid , $addToCartZipCheck': {
                '& > label': {
                    color: '#ff0000',
                },
                [theme.breakpoints.down('880')]: {
                    '&:before': {
                        lineHeight: '15px',
                        height: '16px',
                        bottom: '-7px',
                        fontSize: '12px',
                        width: '100%',
                    },
                },
            },
        },
        [theme.breakpoints.up('880')]: {
            padding: '24px 8px 8px',
            '& $formContainer': {
                display: 'flex',
                flexWrap: 'nowrap',
                alignItems: 'flex-start',
            },
            '& $zipCodeInput , $locationForm , $zipCodeInputV2': {
                margin: '4px 0px 24px',
            },
            '& $zipCodeInput > div , $zipCodeInputV2 > div ': {
                margin: '0px',
                height: '56px',
            },
            '&  $locationForm': {
                paddingLeft: '10px',
            },
            '& $paperBody': {
                padding: '24px 16px 0px',
            },

        },
        '& $paperHeaderLink , $paperHeaderLinkV2': {
            color: theme.palette.cms?.black || '#000000',
            cursor: 'pointer',
            fontSize: '14px',
            lineHeight: '20px',
            marginTop: '24px',
            textDecoration: 'underline',
            textTransform: 'capitalize',
            textUnderlineOffset: '5px',
            textDecorationThickness: '2px',
            fontFamily: 'museo-sans, "Area Variable", LatoBold',
            fontWeight: 700,
        },
        '& $paperHeader , $paperHeaderV2': {
            display: 'block',
            padding: '0 16px',
            width: '100%',
            height: '100%',
            background: 'inherit',
            '& div:last-child': {
                display: 'flex',
                justifyContent: 'start',
            },
        },
        '& $pdpDelivery , $pdpDeliveryV2': {
            fontSize: '24px',
            lineHeight: '30px',
            letterSpacing: '0.5px',
            fontFamily: 'museo-sans, "Area Variable", LatoBold',
            fontWeight: '700',
            '@media screen and (min-width:635px) and (max-width: 880px)': {
                fontSize: '20px',
                paddingRight: '0px',
            },
            '@media screen and (min-width:600px) and (max-width: 635px)': {
                fontSize: '18px',
                paddingRight: '0px',
            },
            [theme.breakpoints.down('600px')]: {
                fontSize: '20px',
                lineHeight: '26px',
            },
        },
        '& $locationSelect': {
            width: '100%',
            minHeight: '56px',
            border: 'solid 1px #C4C4C4',
            borderRadius: 3,
            padding: '2px 12px 2px 0px',
            margin: '0px !important',
            background: theme.palette.tiers?.card?.backgroundColor,
            '& :focus': {
                background: '#ffffff',
            },
            '& .MuiNativeSelect-select': {
                color: theme.palette.giftFinderSelectColor,
                fontSize: '18px',
                lineHeight: '26px',
                padding: '17px 12px 0px',
                minHeight: '26px',
            },
            '& .MuiNativeSelect-filled': {
                border: 'solid 1px #C4C4C4',
                borderRadius: 3,
            },
            '& svg': {
                fill: '#000000',
                top: 'calc(50% - 6px)',
            },

        },
        '& $selectLabel': {
            top: '13px',
            left: '0px',
            color: '#555555',
            fontSize: '12px',
            lineHeight: '18px',
            [theme.breakpoints.up('880')]: {
                left: '10px',
            },
        },
        '& $zipCodeInputValid': {
            '&::after': {
                top: '8px',
                left: '103px',
            },
        },
    },
    locationSelect: {},
    locationForm: {
        width: '100%',
        marginTop: '20px',
    },
    deliveryWrapper: {
        [theme.breakpoints.down('600')]: {
            '& $paperHeader, $formContainer': {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
            },
            '& $formWrapper , $formWrapperV2': {
                margin: '0px 6px 0px 0px',
            },
            '& $locationForm': {
                margin: '0px 0px 0px 6px',
            },
            '& $zipCodeInput , $zipCodeInputV2': {
                '& input': {
                    padding: '23px 12px 9px',
                },
            },
            '& $pdpDelivery': {
                fontSize: '14px',
                lineHeight: '20px',
                textTransform: 'uppercase',
            },
            '& $paperHeaderLink': {
                marginTop: '0px',
            },
            '& $paperBody': {
                padding: '16px',
            },
            '& $zipCodeInputValid': {
                '&::after': {
                    top: '8px',
                    left: '60px',
                },
            },
        },
    },
    pdpShortStyle: {
        '& $root': {
            [theme.breakpoints.down('600')]: {
                marginBottom: '0px',
            },
        },
        '& $paperBody': {
            [theme.breakpoints.down('600')]: {
                padding: '20px 16px 0px',
            },
        },
        '& $formContainer': {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            [theme.breakpoints.down('600')]: {
                marginBottom: '0px',
            },
        },
        '& $formWrapper , $formWrapperV2': {
            margin: '0px 6px 0px 0px',
            [theme.breakpoints.up('600')]: {
                margin: '0px',
            },
        },
        '& $locationForm': {
            paddingLeft: '6px',
            margin: '0px 0px 24px',
        },
        '& $zipCodeInput , $zipCodeInputV2': {
            paddingRight: '6px',
            margin: '0px 0px 24px',
            [theme.breakpoints.down('600')]: {
                paddingRight: '0px',
            },
        },
        '@media screen and (min-width: 600px) and (max-width:700px)': {
            '& $paperBody': {
                padding: '24px 0px 0px',
            },
            '& $paperHeader': {
                padding: '0px !important',
            },
            '& $locationForm': {
                paddingLeft: '4px',
            },
            '& $zipCodeInput , $zipCodeInputV2': {
                paddingRight: '4px !important',
            },
        },
        '& $paperHeader': {
            '& div:last-child': {
                [theme.breakpoints.up('600')]: {
                    marginTop: '4px',
                    fontSize: '16px',
                },
            },
        },
        '& $deliveryWrapper': {
            [theme.breakpoints.down('600')]: {
                '& $paperHeader, $formContainer': {
                    marginBottom: '0px',
                },
            },
        },
    },
    pdpPlaStyle: {
        padding: '0px',
        '& $root': {
            margin: '0px',

        },
        '& $paperHeaderLink , $paperHeaderLinkV2': {
            margin: '0px',
            fontSize: '16px',
            lineHeight: '24px',
            letterSpacing: '0.16px',
            '@media screen and (max-width: 600px)': {
                lineHeight: '20px',
                fontSize: '14px',
            },
        },
        '& $paperBody': {
            padding: '18px 0px 0px',
        },
        '& $locationForm': {
            paddingLeft: '6px',
        },
        '& $zipCodeInput': {
            paddingRight: '6px',
        },
        '& $zipCodeInput , $locationForm , $zipCodeInputV2': {
            margin: '0px 0px 16px',
            '& label': {
                fontSize: '14px',
                '@media screen and (max-width: 1280px) and (min-width:1024px)': {
                    fontSize: '12px',
                },
                '@media screen and (max-width: 380px)': {
                    fontSize: '12px',
                },
            },
            '@media screen and (max-width: 600px)': {
                margin: '0px 0px 20px',
            },
        },
        '& $formContainer': {
            marginBottom: '0px',
            display: 'flex',
        },
        '& $formWrapper , $formWrapperV2': {
            margin: '0px 0px 0px 0px',
        },
        '& $paperHeader, $paperHeaderV2': {
            padding: '0px',
        },
        '& $zipCodeInputInvalid , $addToCartZipCheck': {
            '&:before': {
                width: 'calc(100% - 6px)',
            },
        },
        '& $locationSelect': {
            '& .MuiNativeSelect-select': {
                fontSize: '14px',
            },
        },
    },
    stickyAtcPaperBody: {
        '& $paperBody': {
            paddingBottom: '0px',
        },
        '& .card-isle-pdp-slot div[style*="border-top"], & #card-isle-pdp-block div[style*="border-top"]': {
            display: 'none !important',
        },
    },
    deliveryOptionsAddToCartZipCheck: {
        position: 'relative',
        '&::before': {
            position: 'absolute',
            zIndex: '999',
            color: theme.palette.cms?.red || '#ff0000',
            lineHeight: '25px',
            fontSize: '11px',
            fontWeight: '300',
            content: '"ZIP Code required"',
            bottom: '-25px',
            left: 0,
            paddingLeft: '7px',
            width: 'calc(100% - 8px)',
            height: '25px',
            // backgroundColor: theme.palette.cms?.red || '#ff0000',
            transition: 'opacity 0.3s ease-in',
            opacity: 1,
            [theme.breakpoints.down('sm')]: {
                lineHeight: '18px',
                bottom: '-18px',
                width: 'calc(100% - 4px)',
                height: '20px',
            },
        },
    },
    deliveryDateOptionsContainter: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        fontFamily: 'museo-sans, "Area Variable"',
        gap: '16px',
    },
    deliveryDateOptionsTitle: {
        color: 'var(--ENT-gray-700, #434343)',
        fontFamily: 'museo-sans, "Area Variable"',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '21px', /* 131.25% */
        letterSpacing: '0.64px',
        textTransform: 'uppercase',
    },
    deliveryDateOptionsCopy: {
        color: 'var(--ENT-gray-700, #434343)',
        fontFamily: 'museo-sans, "Area Variable"',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '19px', /* 135.714% */
        margin: 0,
    },
    deliveryDateEmptyState: {
        width: '100%',
        marginTop: '4px',
        borderBottom: '1px solid #E9E9E9',
        paddingBottom: '28px',
        marginBottom: '28px',
    },
    deliveryDateEmptyStateHeader: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '20px',
        width: '100%',
    },
    deliveryDateEmptyStateCopy: {
        margin: 0,
    },
    deliveryDateOptions: {
        minHeight: '139px',
        padding: '16px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        flex: '1 0 0',
        borderRadius: '3px',
        border: '1px solid #D7D9E0',
        background: '#FFFFFF',
        color: '#000',
        textAlign: 'left',
        fontFamily: 'museo-sans, "Area Variable"',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '21px', /* 131.25% */
        letterSpacing: '0.16px',
        gap: '10px',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
        '& p': {
            margin: 0,
        },
        '& .delivery-date': {
            fontFamily: 'museo-sans, "Area Variable", Helvetica, Arial, sans-serif',
            fontSize: '18px',
            fontWeight: 700,
            lineHeight: '21px',
            letterSpacing: '0.16px',
        },
        '& svg': {
            flexShrink: 0,
        },
        [theme.breakpoints.down('1030')]: {
            fontSize: '14px',
            padding: '16px',
        },
        [theme.breakpoints.down('850')]: {
            fontSize: '14px',
            minHeight: '128px',
            padding: '14px',
        },
        [theme.breakpoints.up(1200)]: {
            minHeight: 'auto',
            padding: '12px 16px',
            gap: '8px',
        },
        [theme.breakpoints.down(400)]: {
            minHeight: 'auto',
            padding: '12px',
            gap: '8px',
        },
    },
    deliveryDateOptionsPLA: {
        fontSize: '12px',
        padding: '16px',
        [theme.breakpoints.down('850')]: {
            padding: '14px',
        },
        [theme.breakpoints.up('1030')]: {
            fontSize: '16px',
            padding: '16px',
        },
        [theme.breakpoints.up(1200)]: {
            fontSize: '16px',
            minHeight: '139px',
            padding: '16px',
            gap: '10px',
            '& $deliveryDateOptionContentPrimary': {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: '10px',
            },
            '& $deliveryDateOptionDetails': {
                width: '100%',
                gap: '12px',
            },
            '& $deliveryDateOptionPill': {
                marginTop: 'auto',
                justifySelf: 'auto',
                alignSelf: 'auto',
            },
            '& $deliveryDateOptionRecommendation': {
                justifySelf: 'auto',
                alignSelf: 'auto',
            },
            '& $deliveryDateDesktopNoWrap': {
                whiteSpace: 'normal',
            },
            '& $deliveryDatePickDateSubtitle': {
                whiteSpace: 'normal',
            },
        },
    },
    deliveryDateOptionSelected: {
        border: '1px solid #14571A',
        background: '#F5F8F4',
    },
    deliveryDateButtonsContainer: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        alignItems: 'stretch',
        gap: '16px',
        marginBottom: '16px',
        [theme.breakpoints.up(1200)]: {
            gap: '12px',
        },
        [theme.breakpoints.down(400)]: {
            flexDirection: 'column',
            gap: '8px',
        },
    },
    deliveryDateOptionsSurchargeMessage: {
        color: '#000',
        textAlign: 'left',
        fontFamily: 'museo-sans, "Area Variable"',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '19px', /* 135.714% */
        letterSpacing: '0.14px',
        margin: 0,
        [theme.breakpoints.down('850')]: {
            fontSize: '13px',
        },
        [theme.breakpoints.down('802')]: {
            fontSize: '12px',
        },
        [theme.breakpoints.down('420')]: {
            fontSize: '11px',
        },
        [theme.breakpoints.down('321')]: {
            lineHeight: '15px',
        },
    },
    deliveryDateOptionsSurchargeMessagePLA: {
        fontSize: '12px',
    },
    deliveryDateOptionContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '10px',
        width: '100%',
        flex: 1,
    },
    deliveryDateOptionContentPrimary: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '10px',
        width: '100%',
        flex: 1,
        [theme.breakpoints.up(1200)]: {
            display: 'grid',
            gridTemplateColumns: '1fr auto',
            gridTemplateAreas: `
                "details pill"
                "details recommendation"
            `,
            alignItems: 'start',
            gap: '8px 12px',
        },
        [theme.breakpoints.down(400)]: {
            display: 'grid',
            gridTemplateColumns: '1fr auto',
            gridTemplateAreas: `
                "details pill"
                "details recommendation"
            `,
            alignItems: 'start',
            gap: '8px 12px',
        },
    },
    deliveryDateOptionDetails: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '12px',
        width: '100%',
        [theme.breakpoints.up(1200)]: {
            gridArea: 'details',
            width: 'auto',
        },
        [theme.breakpoints.down(400)]: {
            gridArea: 'details',
            width: 'auto',
        },
    },
    deliveryDateOptionContentSecondary: {
        color: '#2F2F2F',
        '& p, & span, & div': {
            color: '#2F2F2F',
        },
        '& .delivery-date': {
            color: '#2F2F2F',
        },
        '& svg path': {
            fill: '#2F2F2F',
        },
    },
    deliveryDateOptionHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        padding: '2px 8px',
        borderRadius: '4px',
        background: '#E5F0E3',
        color: '#14571A',
        fontFamily: 'museo-sans, "Area Variable", Helvetica, Arial, sans-serif',
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '19px',
    },
    deliveryDateOptionHeaderText: {
        color: '#14571A',
        fontFamily: 'museo-sans, "Area Variable", Helvetica, Arial, sans-serif',
        fontSize: '12px',
        fontWeight: 600,
        lineHeight: '17px',
    },
    deliveryDateOptionHeaderPlain: {
        background: 'transparent',
        padding: 0,
        justifyContent: 'flex-start',
    },
    deliveryDateOptionHeaderInvisible: {
        background: 'transparent',
        color: '#2F2F2F',
        padding: '2px 0',
        '& svg path': {
            fill: '#2F2F2F',
        },
    },
    deliveryDatePickDateTitle: {
        color: '#000',
        fontFamily: 'museo-sans, "Area Variable", Helvetica, Arial, sans-serif',
        fontSize: '12px',
        fontWeight: 600,
        lineHeight: '17px',
    },
    deliveryDateOptionRecommendationPlaceholder: {
        visibility: 'hidden',
        [theme.breakpoints.down(400)]: {
            display: 'none',
        },
    },
    deliveryDateOptionLabel: {
        color: '#2F2F2F',
        fontFamily: 'museo-sans, "Area Variable", Helvetica, Arial, sans-serif',
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '19px',
    },
    deliveryDateOptionRecommendation: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        color: '#2F2F2F',
        fontFamily: 'museo-sans, "Area Variable", Helvetica, Arial, sans-serif',
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '17px',
        [theme.breakpoints.up(1200)]: {
            gridArea: 'recommendation',
            justifySelf: 'end',
            alignSelf: 'end',
        },
        [theme.breakpoints.down(400)]: {
            gridArea: 'recommendation',
            justifySelf: 'start',
            alignSelf: 'end',
        },
    },
    deliveryDateOptionPill: {
        display: 'inline-flex',
        alignItems: 'center',
        padding: '2px 8px',
        borderRadius: '4px',
        background: '#E5F0E3',
        color: '#14571A',
        fontFamily: 'Arial, sans-serif',
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '17px',
        marginTop: 'auto',
        [theme.breakpoints.up(1200)]: {
            gridArea: 'pill',
            marginTop: 0,
            justifySelf: 'end',
            alignSelf: 'start',
        },
        [theme.breakpoints.down(400)]: {
            gridArea: 'pill',
            marginTop: 0,
            justifySelf: 'end',
            alignSelf: 'start',
        },
    },
    deliveryDateOptionPillMuted: {
        background: '#ECEDEF',
        color: '#434343',
    },
    deliveryDatePickDateHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        color: '#000',
        fontFamily: 'museo-sans, "Area Variable", Helvetica, Arial, sans-serif',
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '19px',
        '& svg': {
            width: '11px',
            height: '12px',
            fill: '#000',
        },
    },
    deliveryDatePickDateSubtitle: {
        color: '#434343',
        fontFamily: 'museo-sans, "Area Variable", Helvetica, Arial, sans-serif',
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '19px',
        whiteSpace: 'nowrap',
    },
    deliveryDatePickDateSubtitleSmall: {
        fontSize: '12px',
        lineHeight: '17px',
    },
    deliveryDateDesktopNoWrap: {
        [theme.breakpoints.up(1200)]: {
            whiteSpace: 'nowrap',
        },
    },
    deliveryDateOptionsNoZip: {
        color: 'var(--ENT-gray-900, #000)',
        textAlign: 'left',
        fontFamily: 'museo-sans, "Area Variable"',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '21px', /* 131.25% */
        letterSpacing: '0.16px',
        margin: 0,
        [theme.breakpoints.down('321')]: {
            fontSize: '14px',
        },
    },
    zipRequired: {
        color: '#000',
        textAlign: 'left',
        fontFamily: 'museo-sans, "Area Variable"',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '19px', /* 135.714% */
        letterSpacing: '0.14px',
        margin: 0,
        [theme.breakpoints.down('376')]: {
            fontSize: '12px',
        },
    },
    [theme.breakpoints.down(400)]: {
        deliveryDateButtonsContainer: {
            flexDirection: 'column',
            gap: '12px',
        },
        deliveryDateOptions: {
            width: '100%',
            padding: '16px',
            alignSelf: 'stretch',
        },
        deliveryDateOptionContent: {
            gap: '8px',
        },
        deliveryDateOptionContentPrimary: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            gap: '16px',
        },
        deliveryDateOptionDetails: {
            gap: '8px',
            flex: 1,
        },
        deliveryDateOptionPill: {
            marginTop: 0,
            alignSelf: 'flex-start',
            whiteSpace: 'nowrap',
        },
    },
    addonWrapper: {
        padding: '28px 0px',
        borderTop: '1px solid  var(--ENT-gray-100, #E9E9E9)',
        marginTop: '16px',
    },

});

const isCandaZip = (zipcode) => new RegExp(/^[a-zA-Z]{1}[0-9]{1}[a-zA-Z]{1}[- ]{0,1}[0-9]{1}[a-zA-Z]{1}[0-9]{1}/).test(zipcode);

const getNow = (todayOrTom) => {
    const d = new Date();
    if (todayOrTom === 'tomorrow') {
        const newDate = d.getDate() + 1;
        d.setDate(newDate);
        d.setHours(0, 0, 0, 0);
        return d;
    }
    d.setHours(0, 0, 0, 0);
    return d;
}; // 12:00 midnight of current day

const backupLocationTypeOptions = ['Residence', 'Business', 'Funeral home', 'Hospital', 'Apartment', 'School', 'Church'];
const foodBrandLocationTypeOptions = ['Residence', 'Business', 'APO/FPO'];
export class GraphqlAddToCartContainerUI extends Component {
    constructor(props) {
        super(props);
        const {
            userSubmittedZip, featureFlags, productDeliveryType, validatedZip, variantDeliveryOptions,
        } = this.props;
        this.state = {
            zipField: userSubmittedZip || validatedZip,
            showCalendar: false,
            showAgeVerification: false,
            calendarIsLoading: false,
            deliveryAvailable: true,
            signinIsLoading: false,
            ageDetails: {
                birthDay: '0',
                birthMonth: '0',
                birthYear: '0',
                minAge: '0',
            },
            todayTomArray: [],
            startDateString: '',
            todayTomDateNotAvailText: '',
            personalization: {
                modalOpen: false,
            },
            fireCalendarQuery: false,
            gptSkipCalendarVariantFlowEnabled: (featureFlags['is-skip-calendar-flow-enabled-gpt']?.variant === 'VARIANT A' && productDeliveryType === 'GPT'),
            fireZipCheckQuery: false,
            flexModalOpen: false,
            flexData: null,
            flexTaggingData: null,
            deliveryDateOption: '',
            dateSelectedFromCalendar: {},
            activeButton: 'button1',
            optionOneDate: '',
            optionTwoDate: '',
            productIsNotAvailable: null,
            dateWithSurchargeAvailable: true,
            dateWithoutSurchargeAvailable: true,
            deliveryDateOptionsFlexDetails: null,
            secondButtonFlexDetails: null,
            thirdButtonFlexDetails: null,
            flexDetailsAvailable: false,
            personalizationAdded: false,
            secondButtonSurcharge: '',
            firstButtonDate: '',
            secondButtonDate: '',
            isDeliveryDateOptionsEnabled: featureFlags['is-delivery-date-options-on-pdp-ab-test-enabled'] = true && variantDeliveryOptions && featureFlags[`is-delivery-date-options-enabled-for-${productDeliveryType?.toLowerCase?.()}`],
        };
        this.zipFieldRef = React.createRef();
    }

    componentDidMount() {
        const {
            zipValid, resetFilterZipcodeValidity, callLoadAddressBook, userType, featureFlags, productDeliveryType, trackEvent,
            isWriteScopeCheckout, userSubmittedZip,
        } = this.props;
        const { zipField, isDeliveryDateOptionsEnabled } = this.state;
        if (zipValid === false) {
            resetFilterZipcodeValidity();
        }
        if (userType === 'R' && isWriteScopeCheckout) {
            callLoadAddressBook();
        }
        if (isDeliveryDateOptionsEnabled && ((zipValid === true && zipField.length >= 5) || (userSubmittedZip !== '' && zipField === userSubmittedZip))) {
            this.deliveryDateOptionsGetCalendarAPI();
        }
        if (productDeliveryType === 'GPT') {
            if (featureFlags['is-skip-calendar-flow-enabled-gpt']?.variant === 'VARIANT A') {
                // if the pdp is direct loaded then GA will not have loaded and need to queue the trackEvent
                // however if user navigates to pdp then GA is already loaded and need to dispatch a non-queued version of trackEvent
                trackEvent({
                    eventCategory: 'Test Impression',
                    eventAction: 'GPT No Calendar Variant',
                    queued: true,
                });
                trackEvent({
                    eventCategory: 'Test Impression',
                    eventAction: 'GPT No Calendar Variant',
                });
            }
        }
        if (typeof window !== 'undefined') {
            window.addEventListener('pdp:zip-required', this.handleZipRequired);
        }
    }

    componentWillUnmount() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('pdp:zip-required', this.handleZipRequired);
        }
    }

    handleZipRequired = () => {
        const zipValue = this.state.zipField?.trim();
        if (!zipValue) {
            this.setState({ fireZipCheckQuery: true });
            return false;
        }
        this.setState({ fireZipCheckQuery: false });
        return true;
    };

    componentDidUpdate(prevProps, prevState) {
        const {
            userType, callLoadAddressBook, wineValidation, isWriteScopeCheckout, userSubmittedZip, validatedZip, showProductTitleTop, featureFlags, device, locationType, selectedSku,
        } = this.props;
        const {
            showCalendar,
            showAgeVerification,
            gptSkipCalendarVariantFlowEnabled,
            zipField,
            isDeliveryDateOptionsEnabled,
            deliveryDateOption,
        } = this.state;
        const isPdpDeliveryTopEnabled = featureFlags['is-pdp-delivery-top-enabled'] && device === 'mobile' && showProductTitleTop;
        // stop loading once pdp sign-in is complete
        if (prevProps.userType === 'G' && userType === 'R') {
            this.setState({ signinIsLoading: false });
        }
        if (isPdpDeliveryTopEnabled && (prevProps.validatedZip !== validatedZip || prevProps.userSubmittedZip !== userSubmittedZip)) {
            this.setState(
                {
                    zipField: validatedZip || userSubmittedZip,
                },
                this.validateZip,
            );
        }
        if (isDeliveryDateOptionsEnabled && ((prevProps.locationType !== locationType) || (prevProps.selectedSku !== selectedSku))) {
            this.setState({
                deliveryDateOption: '',
                dateSelectedFromCalendar: {},
                activeButton: 'button1',
                flexDetailsAvailable: false,
                flexData: null,
                deliveryDateOptionsFlexDetails: null,
                secondButtonFlexDetails: null,
                thirdButtonFlexDetails: null,
                startDateString: '',
            });
            this.deliveryDateOptionsGetCalendarAPI('today');
        }
        if ((prevProps.validatedZip !== validatedZip || (prevProps.userSubmittedZip !== '' && prevProps.userSubmittedZip !== userSubmittedZip)) && zipField.length >= 5 && isDeliveryDateOptionsEnabled) {
            this.handleDeliveryAvailability(true);
            this.deliveryDateOptionsGetCalendarAPI('today');
            this.setState({
                activeButton: 'button1',
                dateWithSurchargeAvailable: true,
                dateWithoutSurchargeAvailable: true,
                secondButtonFlexDetails: null,
                thirdButtonFlexDetails: null,
                dateSelectedFromCalendar: {},
            });
        }
        if (!showCalendar && showAgeVerification && this.getAvailability(wineValidation)) {
            if (!gptSkipCalendarVariantFlowEnabled) {
                this.showCalendar();
            } else {
                this.simpleAddToCart();
            }
        }

        // load address book when user signs in
        if ((prevProps.userType === 'G' || prevProps.userType === '' || !prevProps.isWriteScopeCheckout)
            && userType === 'R'
            && isWriteScopeCheckout) {
            callLoadAddressBook();
        }

        //  fire tracking event when deliveryDateOption changes
        if (prevState?.deliveryDateOption !== deliveryDateOption && deliveryDateOption) {
            this.trackDeliveryDateOptionChange(deliveryDateOption);
        }
    }

    trackDeliveryDateOptionChange(deliveryDateOption) {
        try {
            if (!deliveryDateOption) return;

            const { selectedSku, partNumber, dispatchEmitCustomTrackingEvent } = this.props;
            const {
                activeButton, dateSelectedFromCalendar, firstButtonDate, secondButtonDate, todayTomArray, showCalendar,
            } = this.state;

            if (!dispatchEmitCustomTrackingEvent || !partNumber || !selectedSku || showCalendar) return;

            const rawDateMap = {
                button1: firstButtonDate?.deliveryDate,
                button2: secondButtonDate?.deliveryDate,
                button3: dateSelectedFromCalendar?.data?.deliveryDate,
            };
            const rawDate = rawDateMap[activeButton] ?? deliveryDateOption;

            if (!rawDate || rawDate === 'Pick a Date') return;

            const dateObj = new Date(rawDate.split('-').join('/'));
            if (Number.isNaN(dateObj.getTime())) return;

            const dateSelected = format(dateObj, 'yyyy-MM-dd');

            const todayDate = todayTomArray?.[0]?.deliveryDate ?? format(new Date(), 'yyyy-MM-dd');
            const tomorrowDate = todayTomArray?.[1]?.deliveryDate ?? format(addDays(new Date(), 1), 'yyyy-MM-dd');

            let quickDateSelected = null;
            if (activeButton === 'button1' && dateSelected === tomorrowDate) quickDateSelected = 'tomorrow';
            if (activeButton === 'button2' && dateSelected === todayDate) quickDateSelected = 'today';
            if (activeButton === 'button3' || deliveryDateOption === 'Pick a Date') quickDateSelected = 'pickADate';

            // eslint-disable-next-line no-nested-ternary
            const activeDateData = rawDateMap[activeButton] === firstButtonDate?.deliveryDate
                ? firstButtonDate : rawDateMap[activeButton] === secondButtonDate?.deliveryDate
                    ? secondButtonDate : dateSelectedFromCalendar?.data;
            const type = activeDateData?.flexDetails ? 'flex' : 'standard';

            const csPayload = {
                eventSubType: 'feature-tracking',
                action: 'Select',
                label: 'calendar',
                page: { type: 'product' },
                products: [{
                    baseCode: getBaseCode(partNumber),
                    partNumber,
                    price: selectedSku?.prices?.[0]?.value,
                    quantity: 1,
                }],
                calendar: {
                    dateSelected,
                    type,
                    quickDateSelected,
                    exactDateFlag: false, // todo
                },
            };

            dispatchEmitCustomTrackingEvent(csPayload);
        } catch (err) {
            mbpLogger.logError({
                appName: process.env.npm_package_name,
                component: 'GraphqlAddToCartContainerUI',
                message: 'trackDeliveryDateOptionChange failed',
                jsError: err,
            });
        }
    }

    getInternationalCountry = () => {
        let countryCode = '';
        const { selectedSku } = this.props;
        if (selectedSku?.countries?.length > 0) {
            countryCode = filterInternationalCountry(selectedSku.countries);
        }
        return countryCode;
    }

    handleDeliveryAvailability = (boolean) => {
        this.setState({ deliveryAvailable: boolean });
    };

    handleCalendarModal = () => {
        const { productSkus } = this.props;
        if (productSkus[0].ageVerifyFlag === 'true') {
            this.setState({ showCalendar: false, showAgeVerification: true });
        } else {
            this.setState({ showCalendar: true, fireCalendarQuery: true });
        }
    };

    showCalendar = () => {
        const { showAgeVerification } = this.state;
        if (showAgeVerification) {
            this.handleAgeVerificationClose();
        }
        this.setState({ showCalendar: true, calendarIsLoading: true });
    }

    closeCalendar = () => {
        const { todayTomArray, activeButton, isDeliveryDateOptionsEnabled } = this.state;
        const today = todayTomArray?.[0]?.deliveryDate || format(new Date(), 'yyyy-MM-dd');
        this.setState({ showCalendar: false, calendarIsLoading: false });
        if (isDeliveryDateOptionsEnabled && activeButton === 'button1') {
            this.deliveryDateOptionsGetCalendarAPI();
        }
        if (isDeliveryDateOptionsEnabled && activeButton === 'button2') {
            this.setState({
                deliveryDateOption: today !== format(new Date(), 'yyyy-MM-dd') ? 'tomorrow' : 'today',
            });
        }
    };

    handleLocationTypeChange = (e) => {
        const { setLocation, trackEvent } = this.props;
        trackEvent({
            eventCategory: 'Product Page',
            eventAction: 'Location Type',
            eventLabel: e.target.value,
        });
        setLocation(e.target.value);
    };

    calendarButtonNoZip = () => {
        if (typeof document !== 'undefined') {
            const element = document?.getElementById('add-zipcode-text-field');
            if (element) {
                element.focus();
            }
        }
    };

    convertZipCode = (zipcode, preState) => {
        // handle zipcode conversion for canda
        if (preState.length < zipcode.length
            && zipcode.length >= 6
            && isCandaZip(zipcode)) {
            const zipSplit = zipcode.replace(/\s/gi, '').toUpperCase().split('');
            zipSplit.splice(3, 0, ' ');
            return zipSplit.join('');
        }
        return zipcode;
    }

    handleZipChange = (e) => {
        let zipCode = e.target.value;
        const { zipField } = this.state;
        this.setState({ fireZipCheckQuery: false });
        if (isCandaZip(zipCode)) {
            zipCode = this.convertZipCode(zipCode, zipField);
        }
        this.setState(
            {
                zipField: zipCode,
            },
            this.validateZip,
        );
        if (zipCode?.length < 5) {
            this.setState({
                productIsNotAvailable: false,
                todayTomArray: [],
            });
        }
    };

    handleZipFieldKeyPress = (event) => {
        const { todayTomArray, isDeliveryDateOptionsEnabled } = this.state;
        const today = todayTomArray?.[0]?.deliveryDate || format(new Date(), 'yyyy-MM-dd');
        const tomorrow = todayTomArray?.[1]?.deliveryDate || format(addDays(new Date(), 1), 'yyyy-MM-dd');
        if ((event.which && event.which === ENTER_KEY) || (event.keyCode && event.keyCode === ENTER_KEY)) {
            event.preventDefault();
            if (isDeliveryDateOptionsEnabled) {
                this.handleDeliveryDateOptionSelected('tomorrow', today, tomorrow, 'button1');
            } else {
                this.fullCalendarCall();
            }
        }
    };

    setCalendarDataLoadingFlag = (boolean) => {
        this.setState({ calendarIsLoading: boolean });
    };

    displayZipValidCSSCheck = (isInternationalProduct, internationalCountry) => {
        const { zipField, fireZipCheckQuery, isDeliveryDateOptionsEnabled } = this.state;
        const {
            zipValid, classes, userSubmittedZip, featureFlags, displayDeliveryCalendar,
        } = this.props;
        const isInternational = isInternationalProduct && internationalCountry;
        if (
            (zipValid === true && zipField.length >= 5 && !isInternational && zipField !== '00000')
            || (userSubmittedZip !== '' && !isInternational && zipField !== '00000' && zipField === userSubmittedZip)
        ) {
            return `${featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar ? classes.zipCodeInputV2 : classes.zipCodeInput} ${featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar ? '' : classes.zipCodeInputValid}`;
        }
        if ((zipValid === false && zipField.length >= 5) || (zipField === '00000' && !isInternational)) {
            return `${featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar ? classes.zipCodeInputV2 : classes.zipCodeInput} ${classes.zipCodeInputInvalid}`;
        }
        if (fireZipCheckQuery && zipField.length < 5) {
            return `${featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar ? classes.zipCodeInputV2 : classes.zipCodeInput} ${isDeliveryDateOptionsEnabled ? classes.deliveryOptionsAddToCartZipCheck : classes.addToCartZipCheck}`;
        }
        return `${featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar ? classes.zipCodeInputV2 : classes.zipCodeInput}`;
    };

    validateZip = () => {
        // this function determines when to validate a zipcode that the user enters
        const { zipField, isDeliveryDateOptionsEnabled } = this.state;
        const {
            valZip,
            clearValidatedZip,
            zipValid,
            resetZipValidity,
            validatedZip,
            clearFilterZip,
            userSubmittedZip,
        } = this.props;
        if (zipField.length >= 5) {
            // if user enters five chars check if valid zip
            valZip(zipField);
        } else if (zipField.length < 5 && validatedZip !== '') {
            // if there are fewer than 5 chars and there exists a zip in redux clear it
            // we do this so that if someone enters a zipcode, then deletes it the filtering goes away.
            clearValidatedZip(true);
            if (isDeliveryDateOptionsEnabled) {
                this.setState({ deliveryDateOption: '' });
            }
        }
        if (zipField.length < 5 && userSubmittedZip !== '') {
            clearFilterZip();
            if (isDeliveryDateOptionsEnabled) {
                this.setState({ deliveryDateOption: '' });
            }
        }
        if (zipField.length !== 5 && zipValid !== null) {
            // reset the zip is valid flag in redux if zip is not characters.
            resetZipValidity();
            if (isDeliveryDateOptionsEnabled) {
                this.setState({ deliveryDateOption: '' });
            }
        }
    };

    submitUserSelectedZipcode = () => {
        const { zipField } = this.state;
        const {
            validatedZip,
            setFilterZip,
            userSubmittedZip,
            savedAddress,
            clearSavedAddress,
            isPersistAddressEnabled,
        } = this.props;
        if (validatedZip === zipField) {
            setFilterZip(zipField.trimEnd());
        }
        if (userSubmittedZip !== getZipByAddressSource(savedAddress, isPersistAddressEnabled) && !['expressCheckout', 'buyAgain'].includes(savedAddress.addressSource)) {
            // if an address is saved in guided nav but then the user enters a new zipcode in PDP
            // this resets the saved address in redux so it does not incorrectly prefill the previously
            // selected address
            clearSavedAddress();
        }
    };

    handleProductNotAvailableClose = () => {
        const { todayTomArray, isDeliveryDateOptionsEnabled } = this.state;
        const tomorrow = todayTomArray?.[1]?.deliveryDate || format(addDays(new Date(), 1), 'yyyy-MM-dd');
        const tomorrowDate = tomorrow || format(addDays(new Date(), 1), 'yyyy-MM-dd');
        const tomorrowDateSelected = tomorrowDate.split('-').join('/');
        const formattedTomorrowDate = format(new Date(tomorrowDateSelected), 'yyyy-MM-dd');
        this.setState({ deliveryAvailable: true, showCalendar: false, calendarIsLoading: false });
        if (isDeliveryDateOptionsEnabled) {
            this.setState({
                deliveryDateOption: tomorrow !== format(addDays(new Date(), 1), 'yyyy-MM-dd') ? formattedTomorrowDate : 'tomorrow',
                activeButton: 'button1',
            });
        }
    };

    handleAgeVerificationClose = () => {
        this.setState({ showAgeVerification: false });
    }

    /*
    * @description get the availability from API response
    * @param {object} data
    */
    getAvailability = (data) => {
        let availability = false;
        if (!data?.wineAvailability) {
            return false;
        }
        const keys = Object.keys(data.wineAvailability);
        keys.forEach((key) => {
            if (data.wineAvailability[key]?.isProductAvailable) {
                availability = true;
            }
        });
        return availability;
    }

    getAgeVerificationDetails = (birthDay, birthMonth, birthYear) => {
        const { zipField, gptSkipCalendarVariantFlowEnabled } = this.state;
        const {
            productSkus, partNumber, brandId, callVerifyWine,
        } = this.props;

        const { minAge } = productSkus[0];
        this.setState({
            ageDetails: {
                birthDay,
                birthMonth,
                birthYear,
                minAge,
            },
        });

        if (partNumber && (zipField || gptSkipCalendarVariantFlowEnabled) && birthMonth && birthYear && birthDay) {
            const wineData = {
                birthDay,
                birthMonth,
                birthYear,
                brandCode: brandId,
                minAge,
                skuPartNumber: partNumber,
                zipCodes: [zipField],
            };
            callVerifyWine(wineData);
        }
    }

    addTodayOrTomToCart = (todayOrTom) => {
        const {
            validatedZip, userSubmittedZip, trackEvent, location, partNumber,
        } = this.props;
        const { zipField } = this.state;
        const subscriptionProduct = location?.search?.includes('subscription');
        trackEvent({
            eventCategory: subscriptionProduct ? 'subscription' : 'Product Page',
            eventAction: subscriptionProduct ? 'conversion' : 'Purchasing Option',
            eventLabel: subscriptionProduct ? getBaseCode(partNumber) : 'One Time',
            eventValue: '1',
        });
        if ((validatedZip !== '' && validatedZip === zipField) || (userSubmittedZip !== '' && zipField === userSubmittedZip)) {
            trackEvent({ eventCategory: 'Product Page', eventAction: 'Delivery Option Selected', eventLabel: todayOrTom });
            this.submitUserSelectedZipcode();
            this.getCalendarFromAPI(todayOrTom);
        } else {
            this.setState({ fireZipCheckQuery: true });
            this.calendarButtonNoZip();
        }
    }

    updatePersonalizationState = () => {
        this.setState({ personalization: { modalOpen: true } });
    }

    handleFlexClose = () => {
        const { activeButton, secondButtonDate, isDeliveryDateOptionsEnabled } = this.state;
        const surchargeDate = secondButtonDate?.deliveryDate || format(new Date(), 'yyyy-MM-dd');
        const formattedSecondButtonDate = surchargeDate?.split('-').join('/');
        const formattedSurchargeDate = format(new Date(formattedSecondButtonDate), 'yyyy-MM-dd');
        if (isDeliveryDateOptionsEnabled && activeButton === 'button1') {
            this.deliveryDateOptionsGetCalendarAPI();
        } else if (isDeliveryDateOptionsEnabled && activeButton === 'button2') {
            this.setState({
                flexModalOpen: false,
                flexData: null,
                deliveryDateOptionsFlexDetails: null,
                showCalendar: false,
                deliveryDateOption: formattedSurchargeDate,
                flexDetailsAvailable: false,
            });
        } else {
            this.setState({
                flexModalOpen: false,
                flexData: null,
                deliveryDateOptionsFlexDetails: null,
                showCalendar: true,
                deliveryDateOption: '',
                flexDetailsAvailable: false,
            });
        }
    }

    prepareAddToCartTodayTomorrow = () => {
        const { location, selectedSku } = this.props;
        let categoryId = null;
        let categoryName = null;
        let categoryPath = null;
        // if the user direct loads a product page there will be no categoryId
        if (location) {
            categoryPath = location.pathname;

            if (location.state) {
                const { fromCategoryPage } = location.state;

                if (fromCategoryPage) {
                    if (location.state.categoryId) {
                        categoryId = location.state.categoryId;
                    }

                    if (location.state.categoryPath) {
                        categoryPath = location.state.categoryPath;
                    }

                    if (location.state.categoryName) {
                        categoryName = location.state.categoryName;
                    }
                }
            }
        } else {
            categoryId = null;
        }

        let skipAddons = false;

        // sympathyValue: '1' - Home, '2' - Funeral
        if ((location.state && location.state.skipAddons) || (selectedSku?.sympathyValue === '1' || selectedSku?.sympathyValue === '2')) {
            skipAddons = true;
        }

        const attributes = {
            categoryId,
            categoryPath,
            categoryIdent: categoryName,
        };

        return {
            skipAddons,
            attributes,
            categoryId,
            categoryName,
            categoryPath,
        };
    }

    handleFlexDetails = (deliveryDateOptionsFlexDetails) => {
        const { activeButton, secondButtonSurcharge } = this.state;
        const surcharge = deliveryDateOptionsFlexDetails?.flexAmount === '0' && secondButtonSurcharge !== '0.00' ? secondButtonSurcharge : deliveryDateOptionsFlexDetails?.flexAmount;
        if (activeButton === 'button2') {
            this.setState({
                deliveryDateOptionsFlexDetails,
                secondButtonFlexDetails: deliveryDateOptionsFlexDetails,
                flexModalOpen: false,
                flexDetailsAvailable: true,
                secondButtonSurcharge: deliveryDateOptionsFlexDetails?.flexAmount === '0' ? '' : surcharge,
            });
        }
        if (activeButton === 'button3') {
            this.setState({
                deliveryDateOptionsFlexDetails,
                thirdButtonFlexDetails: deliveryDateOptionsFlexDetails,
                flexModalOpen: false,
                flexDetailsAvailable: true,
            });
        }
        this.setState({ deliveryDateOptionsFlexDetails, flexModalOpen: false, flexDetailsAvailable: true });
    }

    handlePickADate = (dateSelected) => {
        const { trackEvent } = this.props;
        const { todayTomArray } = this.state;
        const today = todayTomArray?.[0]?.deliveryDate || format(new Date(), 'yyyy-MM-dd');
        const todayDateChoseFromCalendar = today === dateSelected?.data?.deliveryDate;
        const selectedDateFromCalendar = dateSelected?.data?.deliveryDate;
        const reformattedSelectDateFromCalendar = selectedDateFromCalendar?.split('-').join('/');
        const formattedSelectedDate = format(new Date(reformattedSelectDateFromCalendar), 'yyyy-MM-dd');
        this.setState({
            showCalendar: false,
            calendarIsLoading: false,
            dateSelectedFromCalendar: dateSelected,
            deliveryDateOption: formattedSelectedDate,
            activeButton: 'button3',
        });
        if (todayDateChoseFromCalendar) {
            trackEvent({
                eventAction: 'Delivery Date Option - Fastest Delivery Selected From Calendar',
                eventCategory: 'Delivery Date Options',
                eventLabel: 'Delivery Date Option - Fastest Delivery Selected From Calendar',
            });
        }
        if (dateSelected?.data?.flexDetails) {
            this.setState({
                flexDetailsAvailable: true,
                flexData: dateSelected?.data?.flexDetails?.option,
            });
            this.getCalendarFromAPI(formattedSelectedDate);
        }
    };

    flexTodayTomorrowAddToCart = (flexDate) => {
        const { todayTomArray, startDateString } = this.state;
        const {
            actionAddToCart,
            selectedSku,
            brandId,
            history,
            locationType,
            location,
            subscriptionValues,
            userSubmittedZip,
            partNumber,
            isPassportBundleItem,
            movieSelected,
            hasWine,
            wineValidation,
            isFlowersSubscriptionFeatureEnabled,
            isFlowersTempV1SubscriptionFeatureEnabled,
            subscription,
            subscriptionDetails,
            // trackEvent,
            showWrapup,
            featureFlags,
            isPersistAddressEnabled,
            variantAddon,
            selectAddons,
        } = this.props;

        const {
            skipAddons,
            attributes,
            categoryId,
            categoryName,
            categoryPath,
        } = this.prepareAddToCartTodayTomorrow();

        const selectedDate = todayTomArray?.find((day) => day?.deliveryDate === startDateString);

        let productCode = selectedSku.id;
        let productPartNumber = partNumber;

        /* Feature - FPT / GPT - Back Up Product - Start */

        const backUpProductBrandCode = selectedDate?.backupSkuBrand;
        const backUpProductSkuCode = selectedDate?.backupSkuCode;

        const backUpProduct = checkDateHasBackUpProduct(productCode, backUpProductBrandCode, backUpProductSkuCode);

        if (backUpProduct.hasProduct) {
            productCode = backUpProduct.productCode;
            productPartNumber = backUpProduct.productCode;
        }

        /* Feature - FPT / GPT - Back Up Product - End */
        const quantity = 1;
        const delivery = {
            deliveryDate: formatDate_MM_dd_yyyy_HH_mm_ss(selectedDate.deliveryDate),
            zipCode: userSubmittedZip,
            locationType,
            deliverySLA: selectedDate.deliverySLA,
            deliveryDateType: selectedDate.calendarDateType,
        };

        if (flexDate.optionKey) {
            delivery.flexVariantId = selectedDate.flexDetails?.variantId || '';
            delivery.flexOptionKey = flexDate.optionKey;
            delivery.flexOptionId = flexDate.optionCode;
        }

        // /** supposly is inthe selectedSKUUUUUUUUUUUUU
        /**
         * Passing price rule id that will use to calculate the price dynamically based on the price rules
         */
        // if (selectedSku?.priceRules?.length) {
        //     item.priceRules = selectedSku.priceRules;
        // }

        /* Wine data - Start */
        let wineVerify = {};
        if (hasWine && wineValidation && this.getAvailability(wineValidation) && wineValidation.wineVerify) {
            wineVerify = {
                ...wineValidation.wineVerify,
            };
        }

        let subscriptionData = {};

        // subscription v1 - temporary hardcode
        if (isFlowersSubscriptionFeatureEnabled && !isFlowersTempV1SubscriptionFeatureEnabled && location?.pathname?.includes('subscription')) {
            subscriptionData = {
                isSelected: subscription?.subscriptionCheckbox,
                hasFrequencyList: featureFlags['is-subscription-frequency'],
                hasDurationList: featureFlags['is-subscription-duration'],
                duration: 1,
                interval: 30,
                type: 'Basic',
            };
        }

        if (
            isFlowersSubscriptionFeatureEnabled
            && isFlowersTempV1SubscriptionFeatureEnabled
            && subscription?.subscriptionCheckbox
            && subscriptionDetails
            && subscriptionDetails.subscriptionDurationKey
            && subscriptionDetails.subscriptionFrequency
            && subscriptionDetails.subscriptionType
        ) {
            let duration = subscriptionValues?.duration?.toString?.() || subscriptionDetails.subscriptionDurationKey;
            if (duration.indexOf('.') > 0) {
                duration = duration.substring(0, duration.indexOf('.'));
            }

            let interval = subscriptionValues?.subscriptionInterval?.toString?.() || subscriptionDetails.subscriptionFrequency;
            if (interval.indexOf('.') > 0) {
                interval = interval.substring(0, interval.indexOf('.'));
            }

            subscriptionData = {
                isSelected: subscription?.subscriptionCheckbox,
                hasFrequencyList: featureFlags['is-subscription-frequency'],
                hasDurationList: featureFlags['is-subscription-duration'],
                duration,
                interval,
                type: subscriptionDetails.subscriptionType,
            };
        }

        // if passportBundle flow; redirect to /checkout
        let passportBundle = {};
        if (isPassportBundleItem?.enable) {
            passportBundle = {
                enable: true,
                passportSku: isPassportBundleItem?.passportSku,
            };
        }

        this.trackDeliveryDateOptionChange(''); // todo
        const ATC = new AddToCartBuilderObject(
            brandId,
            productCode,
            quantity,
            [], // cyoSelectedComponents
            selectAddons, // addons
            null, // productLineItemType
            subscriptionData,
            attributes,
            wineVerify,
            {}, // personalizationLines
            {}, // pmallSummaryInfo
            {}, // giftList,
            null, // deliveryIndicatorPDP for gift list
            null, // deliveryMethod for giftlist
            null, // contactId,
            selectedSku,
            delivery,
        );

        const itemObj = ATC.getPayload();

        actionAddToCart({
            item: [itemObj],
            history,
            categoryId,
            partNumber: productPartNumber,
            categoryName,
            categoryPath,
            isMobile: false,
            eventType: 'Product Page',
            passportBundle,
            movieSelected,
            skipAddons,
            showWrapup,
            deliveryDate: selectedDate.date,
            location,
            isPersistAddressEnabled,
            variantAddon,
        });
    }

    checkIfDateExsist = (todayOrTom) => {
        const {
            todayTomArray,
            startDateString,
            personalization,
            flexData,
            flexDetailsAvailable,
            isDeliveryDateOptionsEnabled,
            deliveryDateOption,
        } = this.state;
        const {
            actionAddToCart,
            selectedSku,
            brandId,
            history,
            locationType,
            location,
            productDeliveryType,
            userSubmittedZip,
            partNumber,
            isPassportBundleItem,
            movieSelected,
            hasWine,
            wineValidation,
            isFlowersSubscriptionFeatureEnabled,
            isFlowersTempV1SubscriptionFeatureEnabled,
            subscription,
            subscriptionDetails,
            subscriptionValues,
            trackEvent,
            showWrapup,
            featureFlags,
            isPersistAddressEnabled,
            variantAddon,
            selectAddons,
        } = this.props;

        const {
            skipAddons,
            attributes,
            categoryId,
            categoryName,
            categoryPath,
        } = this.prepareAddToCartTodayTomorrow();

        let doesDateMatchCalDate;
        let brandCode = brandId;
        for (let i = 0; i < todayTomArray.length; i += 1) {
            if (todayTomArray[i]?.deliveryDate === startDateString) {
                const selectedDate = todayTomArray[i];
                if (selectedDate.flexDetails || (isDeliveryDateOptionsEnabled && flexDetailsAvailable)) {
                    const flexTaggingData = {
                        zipcode: userSubmittedZip,
                        delierytype: productDeliveryType,
                        date: format(new Date(selectedDate.deliveryDate?.split('-')?.join('/')), 'yyyy-MM-dd'),
                    };
                    this.setState({
                        flexModalOpen: true,
                        flexData: isDeliveryDateOptionsEnabled && flexDetailsAvailable && !selectedDate.flexDetails ? flexData : selectedDate.flexDetails.option,
                        flexTaggingData,
                        calendarIsLoading: false,
                    });
                    return;
                }
                doesDateMatchCalDate = true;

                let productCode = selectedSku.id;
                let productPartNumber = partNumber;

                /* Feature - FPT / GPT - Back Up Product - Start */

                const backUpProductBrandCode = selectedDate?.backupSkuBrand;
                const backUpProductSkuCode = selectedDate?.backupSkuCode;

                const backUpProduct = checkDateHasBackUpProduct(productCode, backUpProductBrandCode, backUpProductSkuCode);

                if (backUpProduct.hasProduct) {
                    brandCode = backUpProductBrandCode;
                    productCode = backUpProduct.productCode;
                    productPartNumber = backUpProduct.productCode;
                }
                /* Feature - FPT / GPT - Back Up Product - End */
                const quantity = 1;
                const delivery = {
                    deliveryDate: formatDate_MM_dd_yyyy_HH_mm_ss(selectedDate.deliveryDate),
                    zipCode: userSubmittedZip,
                    locationType,
                    deliverySLA: selectedDate.deliverySLA,
                    deliveryDateType: selectedDate.calendarDateType,
                };

                // /** supposly is inthe selectedSKUUUUUUUUUUUUU
                /**
                 * Passing price rule id that will use to calculate the price dynamically based on the price rules
                 */
                // if (selectedSku?.priceRules?.length) {
                //     item.priceRules = selectedSku.priceRules;
                // }

                /* Wine data - Start */
                let wineVerify = {};
                if (hasWine && wineValidation && this.getAvailability(wineValidation) && wineValidation.wineVerify) {
                    wineVerify = {
                        ...wineValidation.wineVerify,
                    };
                }

                let subscriptionData = {};

                // subscription v1 - temporary hardcode
                if (isFlowersSubscriptionFeatureEnabled && !isFlowersTempV1SubscriptionFeatureEnabled && location?.pathname?.includes('subscription')) {
                    subscriptionData = {
                        isSelected: subscription?.subscriptionCheckbox,
                        hasFrequencyList: featureFlags['is-subscription-frequency'],
                        hasDurationList: featureFlags['is-subscription-duration'],
                        duration: 1,
                        interval: 30,
                        type: 'Basic',
                    };
                }

                if (isFlowersSubscriptionFeatureEnabled && isFlowersTempV1SubscriptionFeatureEnabled
                    && subscription?.subscriptionCheckbox
                    && subscriptionDetails
                    && subscriptionDetails.subscriptionDurationKey
                    && subscriptionDetails.subscriptionFrequency
                    && subscriptionDetails.subscriptionType) {
                    let duration = subscriptionValues?.duration?.toString?.() || subscriptionDetails.subscriptionDurationKey;
                    if (duration.indexOf('.') > 0) {
                        duration = duration.substring(0, duration.indexOf('.'));
                    }

                    let interval = subscriptionValues?.subscriptionInterval?.toString?.() || subscriptionDetails.subscriptionFrequency;
                    if (interval.indexOf('.') > 0) {
                        interval = interval.substring(0, interval.indexOf('.'));
                    }

                    subscriptionData = {
                        isSelected: subscription?.subscriptionCheckbox,
                        hasFrequencyList: featureFlags['is-subscription-frequency'],
                        hasDurationList: featureFlags['is-subscription-duration'],
                        duration,
                        interval,
                        type: subscriptionValues?.subscriptionType || subscriptionDetails.subscriptionType,
                    };
                }

                // if passportBundle flow; redirect to /checkout
                let passportBundle = {};
                if (isPassportBundleItem?.enable) {
                    passportBundle = {
                        enable: true,
                        passportSku: isPassportBundleItem?.passportSku,
                    };
                }

                /**
             * Handle req object personlization fields
             * for internal products
             */
                let personalizationLines;
                const personalizationObj = {
                    isPersonalizable: false,
                    personalizedData: {},
                };

                if (personalization?.lineState) {
                    personalizationLines = personalization.lineState?.map((line, index) => ({
                        perAttributeId: `${index + 1}`,
                        perAttributeValue: personalization.lineState[index].lineText,
                    }));

                    if (personalizationLines) {
                        personalizationObj.isPersonalizable = true;
                        personalizationObj.personalizedData = {
                            personalizationType: 'PRODUCT_PERSONALIZATION',
                            personalizationLines,
                        };
                    }
                }

                this.trackDeliveryDateOptionChange(deliveryDateOption);
                const ATC = new AddToCartBuilderObject(
                    brandCode,
                    productCode,
                    quantity,
                    [], // cyoSelectedComponents
                    selectAddons, // addons
                    null, // productLineItemType
                    subscriptionData,
                    attributes,
                    wineVerify,
                    personalizationObj, // personalizationLines
                    {}, // pmallSummaryInfo
                    {}, // giftList,
                    null, // deliveryIndicatorPDP for gift list
                    null, // deliveryMethod for giftlist
                    null, // contactId,
                    selectedSku,
                    delivery,
                );

                const itemObj = ATC.getPayload();

                trackEvent({
                    eventCategory: 'Product Page',
                    eventAction: `Add to Cart - ${todayOrTom}`,
                    eventLabel: productCode,
                });

                actionAddToCart({
                    item: [itemObj],
                    history,
                    categoryId,
                    partNumber: productPartNumber,
                    categoryName,
                    categoryPath,
                    isMobile: false,
                    eventType: 'Product Page',
                    passportBundle,
                    movieSelected,
                    skipAddons,
                    showWrapup,
                    deliveryDate: selectedDate.date,
                    location,
                    isPersistAddressEnabled,
                    variantAddon,
                });
                break;
            }
        }

        if (!doesDateMatchCalDate) {
            let todayTomDateNotAvailText = 'Today or tomorrow is no longer available for this zip. Please select a new date';
            if (todayOrTom === 'today') {
                todayTomDateNotAvailText = 'Today is no longer available for this zip. Please select a new date';
            } else if (todayOrTom === 'tomorrow') {
                todayTomDateNotAvailText = 'Tomorrow is no longer available for this zip. Please select a new date';
            }
            this.setState({
                todayTomDateNotAvailText,
            });
            this.submitUserSelectedZipcode();
            this.handleCalendarModal();
            this.setCalendarDataLoadingFlag(
                true,
            );
        }
        this.setState({
            calendarIsLoading: false,
        });
    }

    generateTodayTomState = (todayTomCalendarDates, startDate, todayOrTom) => {
        const { isDeliveryDateOptionsEnabled } = this.state;
        const formattedDate = todayOrTom === 'today' || todayOrTom === 'tomorrow' ? format(getNow(todayOrTom), 'yyyy-MM-dd') : todayOrTom;
        this.setState({
            todayTomArray: todayTomCalendarDates,
            startDateString: isDeliveryDateOptionsEnabled ? formattedDate : startDate,
            ...(isDeliveryDateOptionsEnabled && formattedDate ? { deliveryDateOption: formattedDate } : {}),
        },
        () => { this.checkIfDateExsist(todayOrTom); });
    }

    isInternationalProduct = () => {
        const { selectedSku } = this.props;
        return selectedSku?.isInternational || false;
    }

    simpleAddToCart = (returnObject = false) => {
        // this add to cart is used when an 18F user views a product for a brand that does
        // not display delivery calendar on pdp
        const { personalization } = this.state;
        const {
            actionAddToCart, selectedSku, brandId, history, partNumber, categoryId, categoryName, categoryPath,
            subscriptionDetails, subscription, isFlowersSubscriptionFeatureEnabled, isFlowersTempV1SubscriptionFeatureEnabled, selectAddons,
            pmallSummaryInfo, featureFlags, isPassportBundleProduct, productCategories, isPersistAddressEnabled, variantAddon,
        } = this.props;

        let productCode = selectedSku.id;
        if (productCode?.indexOf('-') >= 0) {
            productCode = productCode.split('-');
            productCode = productCode[productCode.length - 1];
        }

        const reqObj = {
            brandCode: brandId,
            productCode,
            quantity: 1,
            attributes: [],
        };

        // handling attributes
        if (categoryId) {
            reqObj.attributes.push({
                attributeName: 'categoryId',
                attributeValue: categoryId,
            });
        }
        if (categoryPath) {
            reqObj.attributes.push({
                attributeName: 'categoryPath',
                attributeValue: categoryPath,
            });
        }

        if (categoryName) {
            reqObj.attributes.push({
                attributeName: 'categoryIdent',
                attributeValue: categoryName,
            });
        }

        /**
         * Passing price rule id that will use to calculate the price dynamically based on the price rules
         */
        if (selectedSku?.priceRules?.length) {
            reqObj.priceRules = selectedSku.priceRules;
        }

        let personalizationLines;
        if (personalization?.lineState) {
            personalizationLines = personalization.lineState?.map((line, i) => ({
                perAttributeId: `${i + 1}`,
                perAttributeValue: personalization.lineState[i].lineText,
            }));
        }

        /**
             * Handle req object personlization fields
             * for internal products
             */
        if (personalizationLines) {
            reqObj.personalization = {
                personalizationType: 'PRODUCT_PERSONALIZATION',
                personalizationLines,
            };
        }

        if (selectedSku.productType === 'CLUB' || selectedSku.productType === 'COLLECTION') {
            reqObj.lineItemType = selectedSku.productType;
        }

        // The products only needs firstname, lastname and email,
        // without send emails at the end of place order (example: market place vendor)
        if (
            selectedSku?.parentProduct?.categories?.includes('digital_delivery')
            || productCategories?.includes('digital_delivery')
        ) {
            reqObj.lineItemType = 'DDELVR';
        }

        let skipAddons = false;
        if (
            selectedSku?.parentProduct?.categories?.includes('donations')
            || productCategories?.includes('donations')
        ) {
            skipAddons = true;
        }

        // The product when is NBCU
        if (
            selectedSku?.parentProduct?.categories?.includes('digital_products')
            || selectedSku?.name?.toLowerCase()?.includes('digital movie gift')
            || productCategories?.includes('digital_products')
        ) {
            reqObj.lineItemType = 'NBCU';
        }

        if (featureFlags['is-pmall-enabled'] && pmallSummaryInfo?.customizations?.refnum) {
            const pmallLines = [
                {
                    perAttributeId: 'description',
                    perAttributeValue: pmallSummaryInfo.customizations.description,
                },
                {
                    perAttributeId: 'previewUrl',
                    perAttributeValue: pmallSummaryInfo.customizations.imageURL,
                },
            ];

            reqObj.personalization = {
                personalizationType: 'EXTERNAL',
                personalizationId: pmallSummaryInfo.customizations.refnum,
                personalizationLines: pmallLines,
            };

            if (pmallSummaryInfo?.customizations?.addonCount) {
                reqObj.personalization.addonCount = pmallSummaryInfo.customizations.addonCount;
            }
        }

        if (isFlowersSubscriptionFeatureEnabled && isFlowersTempV1SubscriptionFeatureEnabled
            && subscription?.subscriptionCheckbox
            && subscriptionDetails
            && subscriptionDetails.subscriptionDurationKey
            && subscriptionDetails.subscriptionFrequency
            && subscriptionDetails.subscriptionType) {
            let duration = subscriptionDetails.subscriptionDurationKey;
            if (duration.indexOf('.') > 0) {
                duration = duration.substring(0, duration.indexOf('.'));
            }

            let interval = subscriptionDetails.subscriptionFrequency;
            if (interval.indexOf('.') > 0) {
                interval = interval.substring(0, interval.indexOf('.'));
            }

            reqObj.subscription = {
                duration,
                interval,
                type: subscriptionDetails.subscriptionType,
            };
        }
        if (selectAddons?.length > 0) {
            reqObj.components.addons = selectAddons;
        }

        if (returnObject) {
            return {
                reqObj,
                history,
                partNumber,
                categoryId,
                categoryName,
                categoryPath,
                skipAddons,
            };
        }

        actionAddToCart({
            item: [reqObj],
            history,
            categoryId,
            partNumber,
            categoryName,
            categoryPath,
            enableMinicart: false,
            isMobile: false,
            eventType: 'Product Page',
            passportBundle: isPassportBundleProduct,
            skipAddons,
            isPersistAddressEnabled,
            variantAddon,
        });

        return null;
    };

    flexTestId = () => {
        const {
            featureFlags,
            flags,
            trackEvent,
            productDeliveryType,
        } = this.props;
        let flexTestId = null;
        if (featureFlags['is-flex-test-enabled']) {
            const flexTestImpression = (type, flexId) => (trackEvent({
                eventCategory: 'Test Impression',
                eventAction: `Experiment Flex Test ${type}`,
                eventLabel: `Flex Test ${type}: ${flexId}`,
                nonInteraction: true,
            }));
            if (flags?.whichFlexTestGpt?.variant && productDeliveryType === 'GPT') {
                flexTestId = flags?.whichFlexTestGpt.variant;
                flexTestImpression(productDeliveryType, flexTestId);
            }
            if (flags?.whichFlexTestFpt?.variant && productDeliveryType === 'FPT') {
                flexTestId = flags?.whichFlexTestFpt.variant;
                flexTestImpression(productDeliveryType, flexTestId);
            }
        }
        return flexTestId;
    }

    deliveryDateOptionsGetCalendarAPI = async () => {
        const {
            locationType,
            validatedZip,
            auth,
            selectedSku,
            brandId,
            isAuthenticated,
            passportInCart,
            isPassportUser,
        } = this.props;

        const { zipField } = this.state;
        const deliveryDateOptionsStartDate = new Date();
        deliveryDateOptionsStartDate.setHours(0, 0, 0, 0);// 12:00 midnight of current day
        const startDeliveryDate = format(deliveryDateOptionsStartDate, 'd-MMM-yy');

        const jwt = await auth.getAccessTokenSafely();

        // Starting at the end of the string (backwards pattern matching), continue to match any characters that aren't '-' or '_'
        const itemSku = selectedSku.id.match(/[^-_]*$/);
        let customerType = isAuthenticated ? 'R' : 'G';
        if (passportInCart || (isAuthenticated && isPassportUser)) {
            customerType = 'P';
        }

        availablityDeliveryCalendar({
            env: {},
            jwtToken: jwt,
            brandCode: brandId,
            productCode: itemSku?.[0],
            locationType,
            zipCode: zipField,
            startDate: startDeliveryDate,
            variantId: this.flexTestId() || null,
            customerType,
        })
            .then(({ data }) => {
                if (!data.response.calendarDates) {
                    this.submitUserSelectedZipcode();
                    this.handleDeliveryAvailability(false);
                    this.setState({
                        todayTomArray: [],
                        startDateString: '',
                    });
                    return;
                }
                this.setState({ productIsNotAvailable: false });
                const firstElementWithoutSurcharge = data.response.calendarDates.find((date) => date.surcharge === '0.00' && date.upcharge === '0.0' && !date.flexDetails);
                const firstFlexDate = data?.response?.calendarDates?.find((date) => date?.flexDetails);
                const firstElementWithSurcharge = data.response.calendarDates.find((date) => date.surcharge !== '0.00' || date.upcharge !== '0.0' || date.flexDetails);
                const showButtonWithSurcharge = firstElementWithSurcharge || data.response.calendarDates[0];
                if (!firstElementWithSurcharge) {
                    this.setState({ dateWithSurchargeAvailable: false });
                }
                if (!data.response.calendarDates.find((date) => date.surcharge === '0.00' && date.upcharge === '0.0' && !date.flexDetails)) {
                    this.setState({ dateWithoutSurchargeAvailable: false });
                }
                const firstOptionDate = firstElementWithoutSurcharge;
                const secondOptionDate = showButtonWithSurcharge;
                let secondOptionSurcharge = (Number(showButtonWithSurcharge?.surcharge || 0) + Number(showButtonWithSurcharge?.upcharge || 0)).toFixed(2);
                if (showButtonWithSurcharge?.flexDetails) {
                    const maxSurcharge = Math.max(...showButtonWithSurcharge?.flexDetails?.option.map((o) => Number(o.flexAmount)));
                    secondOptionSurcharge = maxSurcharge.toFixed(2) === '0.00' ? secondOptionSurcharge : maxSurcharge.toFixed(2);
                }
                const todayTomCalendarDates = [secondOptionDate, firstOptionDate];
                let firstDateIsFlexStartDate;
                let formattedFlexDateRange;
                if (firstFlexDate) {
                    const flexRangeStartDate = firstFlexDate && firstFlexDate?.flexDetails?.option?.[0]?.rangeStartDate;
                    const flexRangeEndDate = firstFlexDate && firstFlexDate?.flexDetails?.option?.[0]?.rangeEndDate;
                    const reformattedRangeStartDate = format(new Date(flexRangeStartDate), 'yyyy-MM-dd');
                    const reformattedRangeEndDate = format(new Date(flexRangeEndDate), 'yyyy-MM-dd');
                    const firstButtonFlexRangeStartDate = reformattedRangeStartDate?.split('-').join('/');
                    const firstButtonFlexRangeEndDate = reformattedRangeEndDate?.split('-').join('/');
                    firstDateIsFlexStartDate = firstFlexDate?.flexDetails?.option?.length === 2 && reformattedRangeEndDate === format(new Date(), 'yyyy-MM-dd');
                    formattedFlexDateRange = `${format(new Date(firstButtonFlexRangeStartDate), 'MMM d')} - ${format(new Date(firstButtonFlexRangeEndDate), 'MMM d')}`;
                }
                const standardOptionDate = firstOptionDate.deliveryDate;
                const tomorrowDateSelected = standardOptionDate.split('-').join('/');
                const formattedTomorrowDate = format(new Date(tomorrowDateSelected), 'yyyy-MM-dd');
                const fastestOptionDate = secondOptionDate?.deliveryDate;
                const todayDateSelected = fastestOptionDate?.split('-').join('/');
                const formattedTodayDate = fastestOptionDate && format(new Date(todayDateSelected), 'MMM d');
                const formattedFirstOptionDate = formattedTodayDate;
                const formattedSecondOptionDate = format(new Date(tomorrowDateSelected), 'MMM d');
                const secondButtonDeliveryDate = formattedTomorrowDate;

                this.setState({
                    todayTomArray: todayTomCalendarDates,
                    deliveryDateOption: secondButtonDeliveryDate,
                    optionOneDate: formattedFirstOptionDate,
                    optionTwoDate: firstDateIsFlexStartDate ? formattedFlexDateRange : formattedSecondOptionDate,
                    firstButtonDate: firstOptionDate,
                    secondButtonDate: secondOptionDate,
                    secondButtonSurcharge: secondOptionSurcharge,
                    deliveryDateOptionsFlexDetails: firstDateIsFlexStartDate ? firstFlexDate?.flexDetails?.option?.[0] : null,
                    flexDetailsAvailable: firstDateIsFlexStartDate,
                    startDateString: firstDateIsFlexStartDate ? todayTomCalendarDates?.[0]?.deliveryDate : '',
                });
            })
            .catch((err) => {
                this.setState({ productIsNotAvailable: true });
                mbpLogger.logError({
                    appName: process.env.npm_package_name,
                    component: 'GraphqlPDPCalendar',
                    apiCall: 'availablityDeliveryCalendar',
                    jsError: err,
                    jwt,
                    itemSku,
                    brandId,
                    validatedZip,
                    locationType,
                    startDeliveryDate,
                    customerType,
                });
            });
    }

    getCalendarFromAPI = async (todayOrTom) => {
        const {
            firstButtonDate,
            secondButtonDate,
            zipField,
            isDeliveryDateOptionsEnabled,
        } = this.state;
        const {
            locationType,
            validatedZip,
            auth,
            selectedSku,
            brandId,
            isAuthenticated,
            passportInCart,
            isPassportUser,
            featureFlags,
        } = this.props;
        this.setState({
            calendarIsLoading: true,
        });
        let startDate;
        startDate = format(getNow(todayOrTom), 'yyyy-MM-dd');

        const jwt = await auth.getAccessTokenSafely();

        // Starting at the end of the string (backwards pattern matching), continue to match any characters that aren't '-' or '_'
        const itemSku = selectedSku.id.match(/[^-_]*$/);
        let customerType = isAuthenticated ? 'R' : 'G';
        if (passportInCart || (isAuthenticated && isPassportUser)) {
            customerType = 'P';
        }

        if (isDeliveryDateOptionsEnabled) {
            const today = format(new Date(), 'yyyy-MM-dd');
            const formattedtodayOrTomDate = todayOrTom === 'today' ? new Date(today) : new Date(todayOrTom);
            const isStartDateSameMonth = isSameMonth(new Date(today), new Date(formattedtodayOrTomDate));
            const formattedStartDate = todayOrTom === 'today' ? format(new Date(), 'd-MMM-yy') : format(startOfMonth(new Date(todayOrTom)), 'd-MMM-yy');
            const startDeliveryDate = isStartDateSameMonth ? format(new Date(), 'd-MMM-yy') : formattedStartDate;
            if (todayOrTom !== 'today' || todayOrTom !== 'tomorrow') {
                startDate = todayOrTom;
            }
            if (todayOrTom === 'tomorrow') {
                startDate = format(getNow('tomorrow'), 'yyyy-MM-dd');
            }
            if (todayOrTom === 'today') {
                startDate = format(getNow('today'), 'yyyy-MM-dd');
            }

            availablityDeliveryCalendar({
                env: {},
                jwtToken: jwt,
                brandCode: brandId,
                productCode: itemSku?.[0],
                locationType,
                zipCode: zipField,
                startDate: startDeliveryDate,
                variantId: this.flexTestId() || null,
                customerType,
            })
                .then(({ data }) => {
                    if (!data.response.calendarDates) {
                        this.submitUserSelectedZipcode();
                        this.handleDeliveryAvailability(false);
                        this.setState({
                            todayTomArray: [],
                            startDateString: '',
                        });
                        return;
                    }
                    const dateSelectedFromCalendar = data.response.calendarDates?.find((date) => date.deliveryDate === todayOrTom);
                    const todayTomCalendarDates = [secondButtonDate, firstButtonDate, dateSelectedFromCalendar];
                    this.generateTodayTomState(todayTomCalendarDates, startDate, todayOrTom);
                })
                .catch((err) => {
                    this.handleDeliveryAvailability(false);
                    mbpLogger.logError({
                        appName: process.env.npm_package_name,
                        component: 'GraphqlPDPCalendar',
                        apiCall: 'availablityDeliveryCalendar',
                        jsError: err,
                        jwt,
                        itemSku,
                        brandId,
                        validatedZip,
                        locationType,
                        startDate,
                        customerType,
                    });
                });
        } else {
            getDeliveryCalendarByProduct(
                {},
                jwt,
                itemSku,
                brandId,
                validatedZip,
                locationType,
                startDate,
                customerType,
                undefined,
                featureFlags['is-new-flex-flows-enabled'],
            )
                .then(({ data }) => {
                    if (!data.response.calendarDates) {
                        this.submitUserSelectedZipcode();
                        this.handleDeliveryAvailability(false);
                        this.setState({
                            todayTomArray: [],
                            startDateString: '',
                        });
                        return;
                    }
                    const todayTomCalendarDates = [data?.response?.calendarDates?.[0], data?.response?.calendarDates?.[1]];
                    this.generateTodayTomState(todayTomCalendarDates, startDate, todayOrTom);
                })
                .catch((err) => {
                    this.handleDeliveryAvailability(false);
                    mbpLogger.logError({
                        appName: process.env.npm_package_name,
                        component: 'GraphqlPDPCalendar',
                        apiCall: 'getDeliveryCalendarByProduct',
                        jsError: err,
                        jwt,
                        itemSku,
                        brandId,
                        validatedZip,
                        locationType,
                        startDate,
                        customerType,
                    });
                });
        }
    };

    handleAgeVerify = (handleMobileAgeVerification, hasWine) => {
        const { displayDeliveryCalendar } = this.props;
        if (hasWine && !displayDeliveryCalendar) {
            handleMobileAgeVerification(true, this.fullCalendarCall(true));
        } else {
            this.fullCalendarCall();
        }
    };

    fullCalendarCall = (returnObject = false) => {
        const { gptSkipCalendarVariantFlowEnabled } = this.state;
        const {
            validatedZip, userSubmittedZip, trackEvent, selectedSku, displayDeliveryCalendar, location, featureFlags, productSkus, partNumber,
        } = this.props;
        const subscriptionProduct = location.search.includes('subscription');
        const { zipField, todayTomDateNotAvailText } = this.state;
        this.setState({ fireCalendarQuery: true });
        let returnVal = null;
        if (!displayDeliveryCalendar || featureFlags['is-zip-override-fallback-enabled'] || gptSkipCalendarVariantFlowEnabled) {
            if (returnObject) {
                returnVal = this.simpleAddToCart(true);
                return returnVal;
            }
            if (selectedSku.personalization?.lines?.length && selectedSku.personalization?.indicator && selectedSku.personalization.indicator !== '0') {
                // if the item requires personalization then pause the execution of this function and open
                // personalization modal
                this.setState({ personalization: { modalOpen: true } });
                return returnVal;
            }
            if (productSkus[0].ageVerifyFlag === 'true') {
                this.setState({
                    showAgeVerification: true,
                });
                return returnVal;
            }
            this.simpleAddToCart();
            return returnVal;
        }
        trackEvent({
            eventCategory: subscriptionProduct ? 'subscription' : 'Product Page',
            eventAction: subscriptionProduct ? 'conversion' : 'Purchasing Option',
            eventLabel: subscriptionProduct ? getBaseCode(partNumber) : 'One Time',
            eventValue: '1',
        });
        if (this.isInternationalProduct()) {
            trackEvent({ eventCategory: 'Product Page', eventAction: 'Delivery Option Selected', eventLabel: 'More Dates' });
            this.handleCalendarModal();
            this.setCalendarDataLoadingFlag(true);
        } else if ((validatedZip !== '' && validatedZip === zipField) || (userSubmittedZip !== '' && zipField === userSubmittedZip)) {
            trackEvent({ eventCategory: 'Product Page', eventAction: 'Delivery Option Selected', eventLabel: 'More Dates' });
            this.submitUserSelectedZipcode();
            if (selectedSku.personalization?.lines?.length && selectedSku.personalization?.indicator && selectedSku.personalization.indicator !== '0') {
                // if the item requires personalization then pause the execution of this function and open
                // personalization modal
                this.setState({ personalization: { modalOpen: true } });
                return returnVal;
            }
            this.handleCalendarModal();
            this.setCalendarDataLoadingFlag(true);
            if (todayTomDateNotAvailText !== '') {
                this.setState({
                    todayTomDateNotAvailText: '',
                });
            }
        } else {
            this.setState({ fireZipCheckQuery: true });
            this.calendarButtonNoZip();
        }
        return returnVal;
    };

    handlePersonalizationTextFieldChange = (e) => {
        const { personalization } = this.state;
        const stateCopy = personalization;
        if (e.target.value.length <= stateCopy.lineState[Number(e.target.name)].maxChars) {
            // this condition is check and ensure the user does not enter a space as the first character
            if (e.target.value.substring(0, 1) !== ' ') {
                stateCopy.lineState[e.target.name].lineText = e.target.value;
            }
        }
        this.setState({
            personalization: stateCopy,
        });
    }

    handlePersonalizationModalSubmit = () => {
        const {
            personalization,
            gptSkipCalendarVariantFlowEnabled,
            deliveryDateOption,
            personalizationAdded,
            isDeliveryDateOptionsEnabled,
        } = this.state;
        const {
            displayDeliveryCalendar,
            featureFlags,
        } = this.props;
        const newPersonalizationState = { ...personalization, modalOpen: false };
        this.setState({
            personalization: newPersonalizationState,
            calendarIsLoading: true,
        });
        if (!displayDeliveryCalendar || featureFlags['is-zip-override-fallback-enabled'] || gptSkipCalendarVariantFlowEnabled) {
            // if do not want to show calendar then after personalization step directly add to cart
            this.simpleAddToCart();
        }
        if (isDeliveryDateOptionsEnabled && deliveryDateOption !== 'Pick a Date' && !personalizationAdded) {
            this.addTodayOrTomToCart(deliveryDateOption);
        } else {
            this.handleCalendarModal();
        }
    }

    setPersonalizationState = (newState) => {
        this.setState({
            personalization: newState,
        });
    }

    closePersonalizationModal = () => {
        const { todayTomArray, activeButton, isDeliveryDateOptionsEnabled } = this.state;
        const today = todayTomArray?.[0]?.deliveryDate || format(new Date(), 'yyyy-MM-dd');
        if (isDeliveryDateOptionsEnabled && activeButton === 'button1') {
            this.deliveryDateOptionsGetCalendarAPI();
            this.setState({ personalizationAdded: false });
        }
        if (isDeliveryDateOptionsEnabled && activeButton === 'button2') {
            this.setState({
                deliveryDateOption: today !== format(new Date(), 'yyyy-MM-dd') ? 'tomorrow' : 'today',
                personalizationAdded: false,
            });
        }
        this.setState({
            personalization: { modalOpen: false },
            personalizationAdded: false,
        });
    }

    // had to add from DeliveryForm.js
    handleRemoveAddressBook = (addressBookEntryId) => {
        const {
            userType,
            callRemoveAddressBook,
        } = this.props;
        if (userType === 'R' && addressBookEntryId) {
            callRemoveAddressBook(addressBookEntryId);
        }
    }

    handleSelectedAddressBook = (data) => {
        const {
            setLocation, setFilterZip, setSelectedAddress, userSubmittedZip, clearFilterZip, setZipcodeValidity, setValZip,
        } = this.props;
        if (userSubmittedZip) {
            clearFilterZip();
        }

        const addressComponents = data?.addresses[0] || {};
        const postalCode = (addressComponents.zip) ? addressComponents.zip.split('-')[0] : '';

        setLocation(addressComponents?.addressType || 'Residence');
        addressComponents.employerName = addressComponents?.employerName || '';
        addressComponents.firstName = addressComponents?.firstName || '';
        addressComponents.lastName = addressComponents?.lastName || '';
        if (data?.phoneNumber) {
            addressComponents.phoneNumber = data.phoneNumber;
        }
        this.setState({
            zipField: postalCode,
        }, () => {
            setValZip(postalCode);
            setZipcodeValidity(true);
            setFilterZip(postalCode.trimEnd());
        });
        const reduxAddress = {
            addressComponents,
            addressSource: 'pdpAddressBook',
        };
        setSelectedAddress(reduxAddress);
    }

    renderZipVerificationSvg = () => {
        const {
            classes, userSubmittedZip, zipValid,
        } = this.props;
        const { zipField } = this.state;
        return (
            <Typography component="div" align="left" className={classes.labelPay}>
                {((zipValid === true && zipField.length >= 5) || (userSubmittedZip !== '' && zipField === userSubmittedZip)) && (
                    <div className={classes.checkMarkContainer}>
                        <svg
                            className={classes.checkmark}
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 52 52"
                        >
                            <circle className={classes.checkmarkCircle} cx="26" cy="26" r="25" fill="none" />
                            <path className={classes.checkmarkCheck} fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                        </svg>
                    </div>
                )}
            </Typography>
        );
    }

    handleDeliveryOptionsTracking = (optionClicked) => {
        const { trackEvent } = this.props;
        trackEvent({
            eventAction: `Delivery Date Option - ${optionClicked}`,
            eventCategory: 'Delivery Date Options',
            eventLabel: `Clicked-Delivery Date Option - ${optionClicked}`,
        });
    }

    deliveryDateOptionsCopy = (isInternationalProduct, internationalCountry) => {
        const { zipField } = this.state;
        const {
            userSubmittedZip,
            zipValid,
            classes,
            productDeliveryType,
            passportInCart,
            isAuthenticated,
            isPassportUser,
        } = this.props;
        const isInternational = isInternationalProduct && internationalCountry;
        const serviceOrShipping = productDeliveryType === 'FPT' ? 'service' : 'shipping';
        const passportUser = passportInCart || (isAuthenticated && isPassportUser);
        if (
            (zipValid === true && zipField.length >= 5 && zipField !== '00000' && !isInternational)
            || (userSubmittedZip !== '' && zipField !== '00000' && !isInternational && zipField === userSubmittedZip)
        ) {
            if (passportUser) {
                return <p className={classes.deliveryDateOptionsCopy}>{`No standard ${serviceOrShipping} charge as a Celebrations Passport member`}</p>;
            }
            return <p className={classes.deliveryDateOptionsCopy}>{`Standard ${serviceOrShipping} charge calculated at checkout`}</p>;
        }
        return <p className={classes.deliveryDateOptionsCopy}>Enter a ZIP Code to see delivery dates</p>;
    }

    handleDeliveryDateOptionSelected = (todayOrTomorrow, today, tomorrow, buttonId) => {
        const { zipValid, userSubmittedZip, selectedSku } = this.props;
        const {
            zipField,
            productIsNotAvailable,
            deliveryDateOption,
            activeButton,
        } = this.state;
        if (todayOrTomorrow === 'today') {
            if (productIsNotAvailable) {
                return this.fullCalendarCall();
            }
            // after the daily cuttoff time render tomorrow date
            return this.setState({
                deliveryDateOption: today !== format(new Date(), 'yyyy-MM-dd') ? today : 'today',
                activeButton: buttonId,
                personalizationAdded: false,
                flexDetailsAvailable: false,
                flexData: null,
            });
        }

        if (todayOrTomorrow === 'tomorrow') {
            const tomorrowDate = tomorrow !== format(addDays(new Date(), 1), 'yyyy-MM-dd') ? tomorrow : format(addDays(new Date(), 1), 'yyyy-MM-dd');
            const tomorrowDateSelected = tomorrowDate && tomorrowDate?.split('-').join('/');
            const formattedTomorrowDate = tomorrowDateSelected && format(new Date(tomorrowDateSelected), 'yyyy-MM-dd');
            if (productIsNotAvailable) {
                return this.fullCalendarCall();
            }
            // after the daily cuttoff time render day after tomorrow date
            return this.setState({
                deliveryDateOption: tomorrow !== format(addDays(new Date(), 1), 'yyyy-MM-dd') ? formattedTomorrowDate : tomorrow,
                activeButton: buttonId,
                personalizationAdded: false,
                flexDetailsAvailable: false,
                flexData: null,
            });
        }

        if (todayOrTomorrow === 'Pick a Date') {
            // this condition is for when a user selects a date from calendar
            // and then clicks on pick a date again and then closes out the calendar
            // without selecting another date, it will retain the previously selected
            // date and allow the user to add to cart
            const pickADate = deliveryDateOption !== 'Pick a Date' && activeButton === 'button3' ? deliveryDateOption : 'Pick a Date';
            if (!((zipValid === true && zipField.length >= 5) || (userSubmittedZip !== '' && zipField === userSubmittedZip))) {
                this.setState({ activeButton: buttonId });
            }
            this.fullCalendarCall();
            if (selectedSku.personalization?.lines?.length && selectedSku.personalization?.indicator && selectedSku.personalization.indicator !== '0') {
                // if the item requires personalization then pause the execution of this function and open
                // personalization modal
                this.setState({ personalizationAdded: true });
            }
            return this.setState({ deliveryDateOption: pickADate, flexDetailsAvailable: false, flexData: null });
        }

        if (todayOrTomorrow !== 'today' || todayOrTomorrow !== 'tomorrow' || todayOrTomorrow !== 'Pick a Date' || todayOrTomorrow !== '') {
            return this.setState({
                deliveryDateOption: format(addDays(new Date(), 2), 'yyyy-MM-dd'),
                personalizationAdded: false,
                flexDetailsAvailable: false,
                flexData: null,
            });
        }

        return this.setState({ deliveryDateOption: '' });
    }

    deliveryDateOptionButtons = (isInternationalProduct, internationalCountry) => {
        const {
            zipField,
            todayTomArray,
            dateSelectedFromCalendar,
            activeButton,
            optionOneDate,
            optionTwoDate,
            dateWithoutSurchargeAvailable,
            dateWithSurchargeAvailable,
            deliveryDateOptionsFlexDetails,
            secondButtonFlexDetails,
            thirdButtonFlexDetails,
            productIsNotAvailable,
            secondButtonSurcharge,
        } = this.state;
        const {
            classes,
            userSubmittedZip,
            zipValid,
            partNumber,
            featureFlags,
            location,
            validVaseConfiguratorSku,
            isAuthenticated,
            isPassportUser,
            passportInCart,
        } = this.props;
        let reformattedFlexRangeStartDate;
        let reformattedFlexRangeEndDate;
        let secondButtonFlexRangeStartDate;
        let secondButtonFlexRangeEndDate;
        if (dateSelectedFromCalendar?.data?.flexDetails) {
            const flexRangeStartDate = thirdButtonFlexDetails && thirdButtonFlexDetails?.rangeStartDate;
            const flexRangeEndDate = thirdButtonFlexDetails && thirdButtonFlexDetails?.rangeEndDate;
            const reformattedRangeStartDate = format(new Date(flexRangeStartDate), 'yyyy-MM-dd');
            const reformattedRangeEndDate = format(new Date(flexRangeEndDate), 'yyyy-MM-dd');
            reformattedFlexRangeStartDate = reformattedRangeStartDate?.split('-').join('/');
            reformattedFlexRangeEndDate = reformattedRangeEndDate?.split('-').join('/');
        }
        if (todayTomArray?.[0]?.flexDetails) {
            const flexRangeStartDate = secondButtonFlexDetails && secondButtonFlexDetails?.rangeStartDate;
            const flexRangeEndDate = secondButtonFlexDetails && secondButtonFlexDetails?.rangeEndDate;
            const reformattedRangeStartDate = format(new Date(flexRangeStartDate), 'yyyy-MM-dd');
            const reformattedRangeEndDate = format(new Date(flexRangeEndDate), 'yyyy-MM-dd');
            secondButtonFlexRangeStartDate = reformattedRangeStartDate?.split('-').join('/');
            secondButtonFlexRangeEndDate = reformattedRangeEndDate?.split('-').join('/');
        }
        const isVaseConfiguratorProduct = featureFlags['is-vase-configurator-enabled'] && isVaseConfigProduct(partNumber);
        const today = todayTomArray && todayTomArray?.[0]?.deliveryDate;
        const tomorrow = todayTomArray && todayTomArray?.[1]?.deliveryDate;
        const pickADate = dateSelectedFromCalendar?.data?.deliveryDate || format(new Date(), 'yyyy-MM-dd');
        // this formatting is needed to avoid the invalid date error
        const pickedDate = pickADate.split('-').join('/');
        const formattedPickedDate = dateSelectedFromCalendar?.data?.flexDetails && reformattedFlexRangeStartDate !== '1969/12/31' && reformattedFlexRangeStartDate !== reformattedFlexRangeEndDate ? `${format(new Date(reformattedFlexRangeStartDate), 'MMM d')} - ${format(new Date(reformattedFlexRangeEndDate), 'MMM d')}` : format(new Date(pickedDate), 'MMM d');
        let totalSurchargePickedDate = (Number(dateSelectedFromCalendar?.data?.surcharge || 0) + Number(dateSelectedFromCalendar?.data?.upcharge || 0)).toFixed(2);
        if (dateSelectedFromCalendar?.data?.flexDetails) {
            const pickedDateMaxSurcharge = deliveryDateOptionsFlexDetails && Number(deliveryDateOptionsFlexDetails?.flexAmount);
            totalSurchargePickedDate = pickedDateMaxSurcharge?.toFixed(2) === '0.00' && totalSurchargePickedDate !== '0.00' ? totalSurchargePickedDate : pickedDateMaxSurcharge?.toFixed(2);
        }
        const showDateForSecondButton = todayTomArray?.[0]?.flexDetails && secondButtonFlexRangeStartDate !== '1969/12/31' && secondButtonFlexRangeStartDate !== secondButtonFlexRangeEndDate ? `${format(new Date(secondButtonFlexRangeStartDate), 'MMM d')} - ${format(new Date(secondButtonFlexRangeEndDate), 'MMM d')}` : optionOneDate;
        const showDateForFirstButton = optionTwoDate;
        const secondButtonSurchargeFormatted = secondButtonSurcharge === '0' || secondButtonSurcharge === undefined || secondButtonSurcharge === '' ? '' : `+ $${secondButtonSurcharge}`;
        const showPickedDateSurcharge = totalSurchargePickedDate === '0.00' || totalSurchargePickedDate === undefined ? '' : `$${totalSurchargePickedDate}`;
        const isPLALayout = location.search.includes('adtype=pla');
        const activePLAButton = isPLALayout ? `${classes.deliveryDateOptions} ${classes.deliveryDateOptionsPLA} ${classes.deliveryDateOptionSelected}` : `${classes.deliveryDateOptions} ${classes.deliveryDateOptionSelected}`;
        const notActivePLAButton = isPLALayout ? `${classes.deliveryDateOptions} ${classes.deliveryDateOptionsPLA}` : classes.deliveryDateOptions;
        const isDeliveryDateOptionsSurchargePLA = isPLALayout ? `${classes.deliveryDateOptionsSurchargeMessage} ${classes.deliveryDateOptionsSurchargeMessagePLA}` : classes.deliveryDateOptionsSurchargeMessage;
        const pickADateIconOrSurcharge = dateSelectedFromCalendar && dateSelectedFromCalendar?.data?.deliveryDate ? <p className={isDeliveryDateOptionsSurchargePLA}>Standard charge <br /> {showPickedDateSurcharge}</p> : (
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.3327 1.04169C7.67787 1.04169 7.9577 1.32151 7.9577 1.66669V2.70833H13.3743V1.66669C13.3743 1.32151 13.6542 1.04169 13.9993 1.04169C14.3445 1.04169 14.6243 1.32151 14.6243 1.66669V2.70833H16.4993C17.765 2.70833 18.791 3.73434 18.791 4.99999V16.6667C18.791 17.9323 17.765 18.9583 16.4993 18.9583H4.83268C3.56703 18.9583 2.54102 17.9323 2.54102 16.6667V4.99999C2.54102 3.73434 3.56703 2.70833 4.83268 2.70833H6.7077V1.66669C6.7077 1.32151 6.98752 1.04169 7.3327 1.04169ZM6.7077 3.95833H4.83268C4.25739 3.95833 3.79102 4.4247 3.79102 4.99999V7.70833H17.541V4.99999C17.541 4.4247 17.0746 3.95833 16.4993 3.95833H14.6243V5.00002C14.6243 5.3452 14.3445 5.62502 13.9993 5.62502C13.6542 5.62502 13.3743 5.3452 13.3743 5.00002V3.95833H7.9577V5.00002C7.9577 5.3452 7.67787 5.62502 7.3327 5.62502C6.98752 5.62502 6.7077 5.3452 6.7077 5.00002V3.95833ZM17.541 8.95833H3.79102V16.6667C3.79102 17.242 4.25739 17.7083 4.83268 17.7083H16.4993C17.0746 17.7083 17.541 17.242 17.541 16.6667V8.95833Z" fill="black" />
            </svg>
        );
        const isInternational = isInternationalProduct && internationalCountry;
        const validZipCodeCheck = (((zipValid === true && zipField.length >= 5 && zipField !== '00000' && !isInternational) || (userSubmittedZip !== '' && zipField !== '00000' && !isInternational && zipField === userSubmittedZip)) && todayTomArray?.length > 0) && !productIsNotAvailable;
        const passportUser = passportInCart || (isAuthenticated && isPassportUser);
        const firstButtonText = passportUser ? 'Free' : 'Standard charge';
        const secondButtonText = passportUser ? '' : 'Standard charge';
        const passportThirdButtonText = passportUser && dateSelectedFromCalendar && dateSelectedFromCalendar?.data?.deliveryDate ? <p className={isDeliveryDateOptionsSurchargePLA}>{totalSurchargePickedDate === '0.00' || totalSurchargePickedDate === undefined ? firstButtonText : showPickedDateSurcharge}</p> : (
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.3327 1.04169C7.67787 1.04169 7.9577 1.32151 7.9577 1.66669V2.70833H13.3743V1.66669C13.3743 1.32151 13.6542 1.04169 13.9993 1.04169C14.3445 1.04169 14.6243 1.32151 14.6243 1.66669V2.70833H16.4993C17.765 2.70833 18.791 3.73434 18.791 4.99999V16.6667C18.791 17.9323 17.765 18.9583 16.4993 18.9583H4.83268C3.56703 18.9583 2.54102 17.9323 2.54102 16.6667V4.99999C2.54102 3.73434 3.56703 2.70833 4.83268 2.70833H6.7077V1.66669C6.7077 1.32151 6.98752 1.04169 7.3327 1.04169ZM6.7077 3.95833H4.83268C4.25739 3.95833 3.79102 4.4247 3.79102 4.99999V7.70833H17.541V4.99999C17.541 4.4247 17.0746 3.95833 16.4993 3.95833H14.6243V5.00002C14.6243 5.3452 14.3445 5.62502 13.9993 5.62502C13.6542 5.62502 13.3743 5.3452 13.3743 5.00002V3.95833H7.9577V5.00002C7.9577 5.3452 7.67787 5.62502 7.3327 5.62502C6.98752 5.62502 6.7077 5.3452 6.7077 5.00002V3.95833ZM17.541 8.95833H3.79102V16.6667C3.79102 17.242 4.25739 17.7083 4.83268 17.7083H16.4993C17.0746 17.7083 17.541 17.242 17.541 16.6667V8.95833Z" fill="black" />
            </svg>
        );
        const bestValueIcon = (
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M0 0.583333C0 0.261167 0.261167 0 0.583333 0H6.41667C6.57138 0 6.71975 0.0614581 6.82915 0.170854L11.8412 5.18291C12.1671 5.5108 12.3501 5.95434 12.3501 6.41667C12.3501 6.87899 12.1671 7.32253 11.8412 7.65042L11.84 7.65165L7.65771 11.8339C7.65763 11.834 7.65778 11.8338 7.65771 11.8339C7.49523 11.9965 7.30208 12.1257 7.08973 12.2138C6.87728 12.3018 6.64956 12.3472 6.41958 12.3472C6.18961 12.3472 5.96189 12.3018 5.74944 12.2138C5.53704 12.1257 5.34408 11.9967 5.18158 11.834C5.18154 11.834 5.18162 11.8341 5.18158 11.834L0.171095 6.82939C0.0615515 6.71997 0 6.57149 0 6.41667V0.583333ZM1.16667 1.16667V6.17484L6.0064 11.0089L6.00688 11.0094C6.06105 11.0637 6.12539 11.1067 6.1962 11.136C6.26701 11.1654 6.34292 11.1805 6.41958 11.1805C6.49624 11.1805 6.57215 11.1654 6.64296 11.136C6.71378 11.1067 6.77811 11.0637 6.83229 11.0094L11.0138 6.82792C11.014 6.82774 11.0142 6.82756 11.0143 6.82738C11.1226 6.71814 11.1834 6.57052 11.1834 6.41667C11.1834 6.26281 11.1226 6.1152 11.0143 6.00596C11.0142 6.00578 11.014 6.0056 11.0138 6.00542L6.17504 1.16667H1.16667ZM2.91665 3.49998C2.91665 3.17781 3.17781 2.91665 3.49998 2.91665H3.50581C3.82798 2.91665 4.08915 3.17781 4.08915 3.49998C4.08915 3.82215 3.82798 4.08331 3.50581 4.08331H3.49998C3.17781 4.08331 2.91665 3.82215 2.91665 3.49998Z" fill="#14571A" />
            </svg>
        );
        const recommendedIcon = (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#deliveryDateCheckCircleClip)">
                    <path fillRule="evenodd" clipRule="evenodd" d="M10.442 2.51561C9.26018 1.98901 7.93978 1.85856 6.67773 2.1437C5.41569 2.42884 4.27963 3.1143 3.43899 4.09785C2.59835 5.08141 2.09816 6.31035 2.01303 7.6014C1.9279 8.89245 2.26238 10.1764 2.9666 11.2619C3.67081 12.3473 4.70703 13.176 5.9207 13.6244C7.13438 14.0728 8.46048 14.1168 9.70123 13.75C10.942 13.3831 12.0309 12.625 12.8056 11.5887C13.5803 10.5524 13.9993 9.29346 14 7.99961V7.38666C14 7.01847 14.2985 6.71999 14.6667 6.71999C15.0349 6.71999 15.3334 7.01847 15.3334 7.38666V7.99999C15.3325 9.58137 14.8204 11.1205 13.8735 12.387C12.9267 13.6536 11.5958 14.5802 10.0793 15.0286C8.5628 15.4769 6.94201 15.4231 5.45863 14.8751C3.97525 14.327 2.70877 13.3142 1.84806 11.9876C0.987349 10.6609 0.578534 9.09162 0.682583 7.51367C0.786633 5.93572 1.39797 4.43368 2.42543 3.23156C3.45288 2.02944 4.8414 1.19165 6.38389 0.843146C7.92639 0.49464 9.54022 0.654086 10.9847 1.29771C11.321 1.44756 11.4722 1.84168 11.3223 2.17799C11.1725 2.51431 10.7783 2.66546 10.442 2.51561ZM15.1378 2.195C15.3983 2.45522 15.3985 2.87733 15.1383 3.13781L8.47165 9.81114C8.34665 9.93627 8.17705 10.0066 8.00018 10.0066C7.82331 10.0067 7.65367 9.93644 7.52861 9.81138L5.52861 7.81137C5.26826 7.55103 5.26826 7.12892 5.52861 6.86857C5.78896 6.60822 6.21107 6.60822 6.47142 6.86857L7.99978 8.39693L14.195 2.19547C14.4553 1.93499 14.8774 1.93478 15.1378 2.195Z" fill="#14571A" />
                </g>
                <defs>
                    <clipPath id="deliveryDateCheckCircleClip">
                        <rect width="16" height="16" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        );
        const calendarIcon = (
            // <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
            //     <path fillRule="evenodd" clipRule="evenodd" d="M7.3327 1.04169C7.67787 1.04169 7.9577 1.32151 7.9577 1.66669V2.70833H13.3743V1.66669C13.3743 1.32151 13.6542 1.04169 13.9993 1.04169C14.3445 1.04169 14.6243 1.32151 14.6243 1.66669V2.70833H16.4993C17.765 2.70833 18.791 3.73434 18.791 4.99999V16.6667C18.791 17.9323 17.765 18.9583 16.4993 18.9583H4.83268C3.56703 18.9583 2.54102 17.9323 2.54102 16.6667V4.99999C2.54102 3.73434 3.56703 2.70833 4.83268 2.70833H6.7077V1.66669C6.7077 1.32151 6.98752 1.04169 7.3327 1.04169ZM6.7077 3.95833H4.83268C4.25739 3.95833 3.79102 4.4247 3.79102 4.99999V7.70833H17.541V4.99999C17.541 4.4247 17.0746 3.95833 16.4993 3.95833H14.6243V5.00002C14.6243 5.3452 14.3445 5.62502 13.9993 5.62502C13.6542 5.62502 13.3743 5.3452 13.3743 5.00002V3.95833H7.9577V5.00002C7.9577 5.3452 7.67787 5.62502 7.3327 5.62502C6.98752 5.62502 6.7077 5.3452 6.7077 5.00002V3.95833ZM17.541 8.95833H3.79102V16.6667C3.79102 17.242 4.25739 17.7083 4.83268 17.7083H16.4993C17.0746 17.7083 17.541 17.242 17.541 16.6667V8.95833Z" fill="black" />
            // </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M3.50001 0C3.82218 0 4.08334 0.261167 4.08334 0.583333V1.16665H7.58332V0.583333C7.58332 0.261167 7.84449 0 8.16666 0C8.48882 0 8.74999 0.261167 8.74999 0.583333V1.16665H9.91667C10.8832 1.16665 11.6667 1.95015 11.6667 2.91665V11.0833C11.6667 12.0498 10.8832 12.8333 9.91667 12.8333H1.75C0.783502 12.8333 0 12.0498 0 11.0833V2.91665C0 1.95015 0.783502 1.16665 1.75 1.16665H2.91668V0.583333C2.91668 0.261167 3.17784 0 3.50001 0ZM2.91668 2.33331H1.75C1.42783 2.33331 1.16667 2.59448 1.16667 2.91665V4.66665H10.5V2.91665C10.5 2.59448 10.2388 2.33331 9.91667 2.33331H8.74999V2.91667C8.74999 3.23883 8.48882 3.5 8.16666 3.5C7.84449 3.5 7.58332 3.23883 7.58332 2.91667V2.33331H4.08334V2.91667C4.08334 3.23883 3.82218 3.5 3.50001 3.5C3.17784 3.5 2.91668 3.23883 2.91668 2.91667V2.33331ZM10.5 5.83331H1.16667V11.0833C1.16667 11.4055 1.42783 11.6666 1.75 11.6666H9.91667C10.2388 11.6666 10.5 11.4055 10.5 11.0833V5.83331Z" fill="black" />
            </svg>
        );
        const hasPickedDate = Boolean(dateSelectedFromCalendar?.data?.deliveryDate);
        const isPickDateSelected = activeButton === 'button3';
        const pickDateTitle = 'Pick a Date';
        const pickDateSubtitle = hasPickedDate ? 'Arrives on' : 'Choose any day';
        let pickDateFooterText = 'Varies';
        if (hasPickedDate) {
            pickDateFooterText = showPickedDateSurcharge || 'No Additional Fee';
        }
        const fastestDateIsAfterCheapestDate = compareAsc(new Date(todayTomArray?.[0]?.deliveryDate), new Date(todayTomArray?.[1]?.deliveryDate)) === 1;

        if (!validZipCodeCheck) {
            return (
                <div className={`${classes.deliveryDateOptionsContainter} ${classes.deliveryDateEmptyState}`}>
                    <div data-testid="delivery-date-empty-zip-copy">
                        <div className={classes.deliveryDateEmptyStateHeader}>
                            <p className={classes.deliveryDateOptionsTitle}>Delivery date</p>
                            <div className={classes.deliveryDateEmptyStateCopy}>
                                {this.deliveryDateOptionsCopy(isInternationalProduct, internationalCountry)}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        if (!dateWithoutSurchargeAvailable && dateWithSurchargeAvailable) {
            return (
                <div className={classes.deliveryDateOptionsContainter}>
                    <div>
                        {this.deliveryDateOptionsCopy(isInternationalProduct, internationalCountry)}
                    </div>
                    <div
                        className={classes.deliveryDateButtonsContainer}
                        style={{

                        }}
                    >
                        <button type="button" id="button2" className={activeButton === 'button2' ? activePLAButton : notActivePLAButton} onClick={() => { this.handleDeliveryDateOptionSelected('today', today, tomorrow, 'button2'); this.handleDeliveryOptionsTracking('Fastest Delivery'); }} disabled={(zipValid === false) || (isVaseConfiguratorProduct && !validVaseConfiguratorSku) || (zipField === '00000' && !isInternationalProduct)} data-selected={activeButton === 'button2' && true}>
                            {validZipCodeCheck ? (
                                <>
                                    <p class="delivery-date">{showDateForSecondButton}</p>
                                    {passportUser ? (
                                        <p className={isDeliveryDateOptionsSurchargePLA}>{showDateForSecondButton && secondButtonSurchargeFormatted}</p>
                                    ) : (
                                        <p className={isDeliveryDateOptionsSurchargePLA}>{showDateForSecondButton ? secondButtonText : <GraphqlPortalLoader />} <br /> {showDateForSecondButton && secondButtonSurchargeFormatted}</p>
                                    )}
                                </>
                            ) : (
                                <>
                                    <p className={classes.deliveryDateOptionsNoZip}>Fastest</p>
                                    <p className={classes.deliveryDateOptionsNoZip}>delivery</p>
                                </>
                            )}
                        </button>
                        <button type="button" id="button3" className={activeButton === 'button3' ? activePLAButton : notActivePLAButton} onClick={() => { this.handleDeliveryDateOptionSelected('Pick a Date', today, tomorrow, 'button3'); this.handleDeliveryOptionsTracking('Pick a Date'); }} disabled={(zipValid === false) || (isVaseConfiguratorProduct && !validVaseConfiguratorSku) || (zipField === '00000' && !isInternationalProduct)} data-selected={activeButton === 'button3' && true}>
                            {validZipCodeCheck ? (
                                <>
                                    <p class="delivery-date">{dateSelectedFromCalendar && dateSelectedFromCalendar?.data?.deliveryDate ? formattedPickedDate : 'Pick a Date'}</p>
                                    {passportUser ? passportThirdButtonText : pickADateIconOrSurcharge}
                                </>
                            ) : (
                                <>
                                    <p className={classes.deliveryDateOptionsNoZip}>Pick a Date</p>
                                    <p className={classes.zipRequired}>(ZIP required)</p>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.3327 1.04169C7.67787 1.04169 7.9577 1.32151 7.9577 1.66669V2.70833H13.3743V1.66669C13.3743 1.32151 13.6542 1.04169 13.9993 1.04169C14.3445 1.04169 14.6243 1.32151 14.6243 1.66669V2.70833H16.4993C17.765 2.70833 18.791 3.73434 18.791 4.99999V16.6667C18.791 17.9323 17.765 18.9583 16.4993 18.9583H4.83268C3.56703 18.9583 2.54102 17.9323 2.54102 16.6667V4.99999C2.54102 3.73434 3.56703 2.70833 4.83268 2.70833H6.7077V1.66669C6.7077 1.32151 6.98752 1.04169 7.3327 1.04169ZM6.7077 3.95833H4.83268C4.25739 3.95833 3.79102 4.4247 3.79102 4.99999V7.70833H17.541V4.99999C17.541 4.4247 17.0746 3.95833 16.4993 3.95833H14.6243V5.00002C14.6243 5.3452 14.3445 5.62502 13.9993 5.62502C13.6542 5.62502 13.3743 5.3452 13.3743 5.00002V3.95833H7.9577V5.00002C7.9577 5.3452 7.67787 5.62502 7.3327 5.62502C6.98752 5.62502 6.7077 5.3452 6.7077 5.00002V3.95833ZM17.541 8.95833H3.79102V16.6667C3.79102 17.242 4.25739 17.7083 4.83268 17.7083H16.4993C17.0746 17.7083 17.541 17.242 17.541 16.6667V8.95833Z" fill="black" />
                                    </svg>
                                </>
                            )}
                        </button>
                    </div>
                </div>
            );
        }

        return (
            <div className={classes.deliveryDateOptionsContainter}>
                <div>
                    {this.deliveryDateOptionsCopy(isInternationalProduct, internationalCountry)}
                </div>
                <div
                    className={classes.deliveryDateButtonsContainer}
                    style={{

                    }}
                >
                    <button type="button" id="button1" className={activeButton === 'button1' ? activePLAButton : notActivePLAButton} onClick={() => { this.handleDeliveryDateOptionSelected('tomorrow', today, tomorrow, 'button1'); this.handleDeliveryOptionsTracking('Cheapest Delivery'); }} disabled={(zipValid === false) || (isVaseConfiguratorProduct && !validVaseConfiguratorSku) || (zipField === '00000' && !isInternationalProduct)} data-selected={activeButton === 'button1' && true}>
                        {validZipCodeCheck ? (
                            <div className={classes.deliveryDateOptionContentPrimary}>
                                <div className={classes.deliveryDateOptionDetails}>
                                    <div className={`${classes.deliveryDateOptionHeader} ${classes.deliveryDateOptionHeaderPlain}`}>
                                        {bestValueIcon}
                                        <span className={classes.deliveryDateOptionHeaderText}>Best value</span>
                                    </div>
                                    <div>
                                        <p className={classes.deliveryDateOptionLabel}>Arrives on</p>
                                        <p className={`delivery-date ${classes.deliveryDateDesktopNoWrap}`} style={{ color: '#2F2F2F' }}>{showDateForFirstButton || <GraphqlPortalLoader />}</p>
                                    </div>
                                </div>
                                <div className={classes.deliveryDateOptionPill}>
                                    {showDateForFirstButton ? 'No Additional Fee' : <GraphqlPortalLoader />}
                                </div>
                                <div className={classes.deliveryDateOptionRecommendation}>
                                    {recommendedIcon}
                                    <span>Recommended</span>
                                </div>
                            </div>
                        ) : (
                            <>
                                <p className={classes.deliveryDateOptionsNoZip}>Cheapest</p>
                                <p className={classes.deliveryDateOptionsNoZip}>delivery</p>
                            </>
                        )}
                    </button>
                    <button type="button" id="button3" className={activeButton === 'button3' ? activePLAButton : notActivePLAButton} onClick={() => { this.handleDeliveryDateOptionSelected('Pick a Date', today, tomorrow, 'button3'); this.handleDeliveryOptionsTracking('Pick a Date'); }} disabled={(zipValid === false) || (isVaseConfiguratorProduct && !validVaseConfiguratorSku) || (zipField === '00000' && !isInternationalProduct)} data-selected={activeButton === 'button3' && true}>
                        {validZipCodeCheck ? (
                            <div className={`${classes.deliveryDateOptionContentPrimary} ${classes.deliveryDateOptionContentSecondary}`}>
                                <div className={classes.deliveryDateOptionDetails}>
                                    <div className={`${classes.deliveryDateOptionHeader} ${classes.deliveryDateOptionHeaderInvisible} ${classes.deliveryDatePickDateHeader}`}>
                                        {calendarIcon}
                                        <span className={classes.deliveryDatePickDateTitle}>{pickDateTitle}</span>
                                    </div>
                                    {hasPickedDate ? (
                                        <div>
                                            <p className={classes.deliveryDateOptionLabel}>
                                                {pickDateSubtitle}
                                            </p>
                                            <p className={`delivery-date ${classes.deliveryDateDesktopNoWrap}`}>{formattedPickedDate}</p>
                                        </div>
                                    ) : (
                                        <p className={classes.deliveryDatePickDateSubtitle}>
                                            {pickDateSubtitle}
                                        </p>
                                    )}
                                </div>
                                <div className={hasPickedDate ? classes.deliveryDateOptionPill : `${classes.deliveryDateOptionPill} ${classes.deliveryDateOptionPillMuted}`}>
                                    {pickDateFooterText}
                                </div>
                                <div className={`${classes.deliveryDateOptionRecommendation} ${classes.deliveryDateOptionRecommendationPlaceholder}`} aria-hidden="true">
                                    {recommendedIcon}
                                    <span>Recommended</span>
                                </div>
                            </div>
                        ) : (
                            <>
                                <p className={classes.deliveryDateOptionsNoZip}>Pick a Date</p>
                                <p className={classes.zipRequired}>(ZIP required)</p>
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.3327 1.04169C7.67787 1.04169 7.9577 1.32151 7.9577 1.66669V2.70833H13.3743V1.66669C13.3743 1.32151 13.6542 1.04169 13.9993 1.04169C14.3445 1.04169 14.6243 1.32151 14.6243 1.66669V2.70833H16.4993C17.765 2.70833 18.791 3.73434 18.791 4.99999V16.6667C18.791 17.9323 17.765 18.9583 16.4993 18.9583H4.83268C3.56703 18.9583 2.54102 17.9323 2.54102 16.6667V4.99999C2.54102 3.73434 3.56703 2.70833 4.83268 2.70833H6.7077V1.66669C6.7077 1.32151 6.98752 1.04169 7.3327 1.04169ZM6.7077 3.95833H4.83268C4.25739 3.95833 3.79102 4.4247 3.79102 4.99999V7.70833H17.541V4.99999C17.541 4.4247 17.0746 3.95833 16.4993 3.95833H14.6243V5.00002C14.6243 5.3452 14.3445 5.62502 13.9993 5.62502C13.6542 5.62502 13.3743 5.3452 13.3743 5.00002V3.95833H7.9577V5.00002C7.9577 5.3452 7.67787 5.62502 7.3327 5.62502C6.98752 5.62502 6.7077 5.3452 6.7077 5.00002V3.95833ZM17.541 8.95833H3.79102V16.6667C3.79102 17.242 4.25739 17.7083 4.83268 17.7083H16.4993C17.0746 17.7083 17.541 17.242 17.541 16.6667V8.95833Z" fill="black" />
                                </svg>
                            </>
                        )}
                    </button>
                </div>
            </div>
        );
    }

    render() {
        const {
            showCalendar,
            showAgeVerification,
            calendarIsLoading,
            deliveryAvailable,
            ageDetails,
            todayTomDateNotAvailText,
            zipField,
            signinIsLoading,
            personalization,
            fireCalendarQuery,
            gptSkipCalendarVariantFlowEnabled,
            flexModalOpen,
            flexData,
            flexTaggingData,
            deliveryDateOption,
            dateSelectedFromCalendar,
            activeButton,
            deliveryDateOptionsFlexDetails,
            personalizationAdded,
            flexDetailsAvailable,
            productIsNotAvailable,
            optionTwoDate,
            optionOneDate,
            secondButtonDate,
            firstButtonDate,
            isDeliveryDateOptionsEnabled,
        } = this.state;
        const {
            auth,
            classes,
            locationType,
            userSubmittedZip,
            selectedSku,
            zipValid,
            productDeliveryType,
            brandId,
            brand,
            deliveryData,
            isAuthenticated,
            partNumber,
            addressBookEntries,
            addressBookPageOn,
            addressBookTotalPages,
            totalAddresses,
            callLoadAddressBook,
            productName,
            trackEvent,
            featureFlags,
            isPassportBundleItem,
            validatedZip,
            displayDeliveryCalendar,
            movieSelected,
            handleMobileAgeVerification,
            hasWine,
            location: { state, search },
            isPassportBundleProduct,
            isFlowersSubscriptionFeatureEnabled,
            isFlowersTempV1SubscriptionFeatureEnabled,
            subscription,
            subscriptionDetails,
            handleMiniCartModalClick,
            enableMinicart,
            productNotAvailable,
            isStandAloneMovieSku,
            pmallSummaryInfo,
            activeABTests,
            validVaseConfiguratorSku,
            presentationFamily,
            showWrapup,
            isWriteScopeCheckout,
            isAccessBasedOnScopeEnabled,
            isPlaPage,
            productSkus,
            productCategories,
            device,
            content,
            isPdpRedesignEnabled,
            showAddToCart,
            showDeliveryField,
            showProductTitleTop,
            isPdpRedesignShortEnabled,
            addToCartButtonRedesign,
            isPlaRedesignEnabled,
            isPersistAddressEnabled,
            variantDeliveryOptions,
            categoryId,
            variantAddon,
            addToCartPriceShow,
            isCaDelivery,
            isDeliverCharges,
            addToCartPrice,
            stickyAtcEnabled,
            stickyAtcRequiresSavedZip,
            pageType,
            user,
        } = this.props;
        const isTalonOneCreditWidgetEnabled = featureFlags['is-activation-talon-credit-widget-enabled'];
        const cardIsleFlag = featureFlags['card-isle-product-type-control'];
        const cardIsleEnabled = !!cardIsleFlag?.[productDeliveryType?.toLowerCase()];
        const isPmallPersonalizationAttr = (selectedSku?.attributes || [])?.find((attr) => attr.name === 'is_pmall_personalization_enabled');
        const isPmallPersonalizationEnabled = isPmallPersonalizationAttr?.values?.[0]?.value === 'true';
        const isPmallPersonalizationTypeAttr = (selectedSku?.attributes || [])?.find((attr) => attr.name === 'personalization_type_enabled');
        const pmallPersonalizationType = !!isPmallPersonalizationTypeAttr?.values?.[0]?.value;
        const isPmallCardIsleFlow = featureFlags['is-pmall-product-save-atc-enabled']
            && featureFlags['is-pmall-enabled']
            && (brandId === '1030' || brandId === '1033' || isPmallPersonalizationEnabled || pmallPersonalizationType)
            && selectedSku?.personalization?.personalizationAllowed;
        const startDate = format(getNow('today'), 'yyyy-MM-dd');
        if (isDeliveryDateOptionsEnabled && window && typeof window !== 'undefined') {
            if (deliveryDateOptionsFlexDetails) {
                window.dispatchEvent(new CustomEvent('flexdetails', { detail: deliveryDateOptionsFlexDetails }));
            }
        }
        const isInternationalProduct = this.isInternationalProduct();
        const internationalCountry = this.getInternationalCountry();
        const locationTypeOptions = deliveryData.location_type_options || [];
        const isAddressBookEnabled = featureFlags['is-address-book-service-enabled'];
        const categoryPath = state?.categoryPath || '';
        const isCanadian = getCountryCodeByCategoryPath(categoryPath).countryName === 'Canada';
        const isGPTCalendarButtonTextTestActive = activeABTests.gpt_calendar_button_text === 'VARIANT A';
        const isPdpDeliveryTopEnabled = isPdpRedesignEnabled && featureFlags['is-pdp-delivery-top-enabled'] && device === 'mobile' && showProductTitleTop;
        const dateSelected = dateSelectedFromCalendar?.data?.deliveryDate;
        const isConfirmDate = dateSelected ? true : (deliveryDateOption !== 'Pick a Date' || activeButton === 'button1');
        const isInternational = isInternationalProduct && internationalCountry;
        // add calender price in this variable
        const validZipCodeCheck = ((zipValid === true && zipField?.length >= 5 && zipField !== '00000' && !isInternational) || (userSubmittedZip !== '' && zipField !== '00000' && !isInternational && zipField === userSubmittedZip)) && !productIsNotAvailable;
        const isZipSavedForStickyAtc = zipField !== '00000'
            && !isInternational
            && (
                (zipValid === true && zipField?.length >= 5)
                || (userSubmittedZip !== '' && zipField === userSubmittedZip)
                || (validatedZip !== '' && zipField === validatedZip)
            );
        const shouldUseStickyAtcPaperBody = stickyAtcEnabled
            && (!stickyAtcRequiresSavedZip || isZipSavedForStickyAtc);
        let addonDateSelected = '';
        let calenderPrice = '';
        if (activeButton === 'button1' && optionTwoDate) {
            const totalSurchargePickedDate = (Number(firstButtonDate?.surcharge || 0) + Number(firstButtonDate?.upcharge || 0)).toFixed(2);
            calenderPrice = validZipCodeCheck ? totalSurchargePickedDate : 0;
            addonDateSelected = format(new Date(firstButtonDate?.deliveryDate), 'yyyy-MM-dd');
        } else if (activeButton === 'button2' && optionOneDate) {
            let totalSurchargePickedDate = Number(secondButtonDate?.surcharge || 0) + Number(secondButtonDate?.upcharge || 0);
            if (secondButtonDate?.flexDetails && deliveryDateOptionsFlexDetails === null) {
                const maxSurcharge = Math.max(...secondButtonDate.flexDetails.option.map((o) => Number(o.flexAmount)));
                totalSurchargePickedDate = maxSurcharge;
            } else if (deliveryDateOptionsFlexDetails) {
                const maxSurcharge = Math.max(Number(deliveryDateOptionsFlexDetails.flexAmount));
                totalSurchargePickedDate = maxSurcharge;
            }
            calenderPrice = validZipCodeCheck ? Number(totalSurchargePickedDate.toFixed(2)) : 0;
            addonDateSelected = format(new Date(secondButtonDate?.deliveryDate), 'yyyy-MM-dd');
        } else {
            let totalSurchargePickedDate = (Number(dateSelectedFromCalendar?.data?.surcharge || 0) + Number(dateSelectedFromCalendar?.data?.upcharge || 0)).toFixed(2);
            if (dateSelectedFromCalendar?.data?.flexDetails) {
                const pickedDateMaxSurcharge = deliveryDateOptionsFlexDetails && Number(deliveryDateOptionsFlexDetails?.flexAmount);
                totalSurchargePickedDate = pickedDateMaxSurcharge?.toFixed(2);
                if (deliveryDateOptionsFlexDetails && deliveryDateOptionsFlexDetails.flexAmount === '0') {
                    totalSurchargePickedDate = 0;
                }
            }
            calenderPrice = totalSurchargePickedDate || 0;
            addonDateSelected = dateSelected;
        }
        const isDeliveryEnabed = productIsNotAvailable ? true : isConfirmDate;
        // add calender price in this variable
        const totalAddtoCartPrice = (Number(addToCartPrice) + Number(calenderPrice))?.toFixed(2);
        let pdpReskinStyle = '';
        if (isPlaRedesignEnabled) {
            pdpReskinStyle = `${classes.newProductUI} ${classes.pdpPlaStyle}`;
        } else if (isPdpRedesignShortEnabled) {
            pdpReskinStyle = `${classes.newProductUI} ${classes.pdpShortStyle}`;
        } else if (isPdpRedesignEnabled) {
            pdpReskinStyle = classes.newProductUI;
        }
        if (shouldUseStickyAtcPaperBody) {
            pdpReskinStyle = pdpReskinStyle ? `${pdpReskinStyle} ${classes.stickyAtcPaperBody}` : classes.stickyAtcPaperBody;
        }
        const isPmallProduct = featureFlags['is-pmall-enabled'] && (brandId === '1030' || brandId === '1033');
        // TODO bladerunner: temp solution until i can confirm product data is sound
        const isVaseConfiguratorProduct = featureFlags['is-vase-configurator-enabled'] && isVaseConfigProduct(partNumber);

        const floralPLARedesign = activeABTests.is_floral_pla_redesign === 'VARIANT';
        let PLAContainerDesign = false;
        if (isPlaPage && device === 'mobile' && !isPlaRedesignEnabled) {
            PLAContainerDesign = true;
        } else if (isPlaPage && device !== 'mobile' && floralPLARedesign) {
            PLAContainerDesign = true;
        }
        let addToCartDisplatStep = 2;
        if (isPmallProduct) addToCartDisplatStep = 3;

        const handleDeliveryTitle = () => {
            if ((featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar) || isPdpRedesignEnabled) {
                return isPdpDeliveryTopEnabled ? 'Delivery Address' : `${isDeliveryDateOptionsEnabled ? 'Delivery Details' : 'Enter Delivery Destination'}`;
            }
            return `${addToCartDisplatStep}. Enter Delivery Destination`;
        };

        const displayFlowersLocationTypes = () => {
            if (locationTypeOptions.length > 0) {
                return (
                    locationTypeOptions.map((location) => (
                        <MenuItem
                            value={location.name}
                            key={location.name}
                        >
                            {location.name}
                        </MenuItem>
                    ))
                );
            }
            return (
                backupLocationTypeOptions.map((location) => (
                    <MenuItem
                        value={location}
                        key={location}
                    >
                        {location}
                    </MenuItem>
                ))
            );
        };

        const displayFlowersLocationNewTypes = () => {
            if (locationTypeOptions.length > 0) {
                return (
                    locationTypeOptions.map((location) => (
                        <option aria-hidden="true" value={location.name}>{location.name}</option>
                    ))
                );
            }
            return (
                backupLocationTypeOptions.map((location) => (
                    <option aria-hidden="true" value={location}>{location}</option>
                ))
            );
        };

        const selectInput = () => (
            <div className={featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar ? classes.locationWrapperV2 : classes.locationWrapper}>
                <InputLabel
                    className={featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar ? classes.locationTypeLabelV2 : classes.locationTypeLabel}
                    shrink
                    htmlFor="location-type"
                >
                    {deliveryData.location_type_title || 'Location Type'}
                </InputLabel>
                <Select
                    className={featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar ? classes.locationTypeSelectorV2 : classes.locationTypeSelector}
                    inputProps={{
                        name: 'location-type',
                        id: 'location-type',
                        label: 'location-type',
                    }}
                    name="Location Type"
                    data-test="pdp-select-location"
                    id="select-location-type"
                    value={locationType}
                    onChange={this.handleLocationTypeChange}
                    disableUnderline={featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar && 'true'}
                >
                    {featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar && foodBrandLocationTypeOptions.map((location) => (
                        <MenuItem
                            value={location}
                            key={location}
                        >
                            {location}
                        </MenuItem>
                    ))}
                    {!featureFlags['is-new-delivery-calendar-enabled'] && displayFlowersLocationTypes()}
                </Select>
            </div>
        );

        const showFlexModal = () => {
            if (isDeliveryDateOptionsEnabled) {
                return <FlexibleShippingOptions flexAddToCartDeliveryOptions={this.flexTodayTomorrowAddToCart} handleFlexDetails={this.handleFlexDetails} flexData={flexData} isOpen handleFlexClose={this.handleFlexClose} flexTaggingData={flexTaggingData} isDeliveryDateOptionsEnabled={isDeliveryDateOptionsEnabled} activeButton={activeButton} deviceType={device} />;
            }
            return <FlexModal flexAddToCart={this.flexTodayTomorrowAddToCart} flexData={flexData} isOpen handleFlexClose={this.handleFlexClose} flexTaggingData={flexTaggingData} />;
        };

        return (
            <div className={pdpReskinStyle}>
                {flexModalOpen && flexData && showFlexModal()}
                {!deliveryAvailable && userSubmittedZip && <GraphqlProductNotAvailableModal selectedSku={selectedSku} isOpen={!deliveryAvailable && userSubmittedZip} onClose={this.handleProductNotAvailableClose} productName={productName} brand={brand['domain-name']} trackEvent={trackEvent} productNotAvailable={productNotAvailable} />}
                {calendarIsLoading && !(!deliveryAvailable && userSubmittedZip !== '') ? <GraphqlPortalLoader /> : null}
                {signinIsLoading ? <GraphqlPortalLoader /> : null}
                {selectedSku.personalization?.lines && <PersonalizationModal isOpen={personalization.modalOpen} personalization={selectedSku.personalization} setPersonalizationState={this.setPersonalizationState} personalizationState={personalization} handlePersonalizationTextFieldChange={this.handlePersonalizationTextFieldChange} handlePersonalizationModalSubmit={this.handlePersonalizationModalSubmit} closePersonalizationModal={this.closePersonalizationModal} content={content} />}
                <Paper elevation={PLAContainerDesign ? 0 : 1} className={`${classes.root} ${PLAContainerDesign ? classes.containerPosition : ''} ${isPdpDeliveryTopEnabled ? classes.deliveryWrapper : ''}`}>
                    {!PLAContainerDesign && showDeliveryField && (
                        <div className={featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar ? classes.paperHeaderV2 : `${(displayDeliveryCalendar && !featureFlags['is-zip-override-fallback-enabled'] && !gptSkipCalendarVariantFlowEnabled) ? classes.paperHeader : null} ${isProductListingAd(search) ? classes.paperHeaderPla : ''}`}>
                            {(displayDeliveryCalendar && !featureFlags['is-zip-override-fallback-enabled'] && !gptSkipCalendarVariantFlowEnabled && !isPdpRedesignShortEnabled && !isPlaRedesignEnabled) && <div className={featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar ? classes.pdpDeliveryV2 : classes.pdpDelivery} role="heading" aria-level="5">{handleDeliveryTitle()}</div>}
                            {
                                isAddressBookEnabled && !isInternationalProduct && (displayDeliveryCalendar
                                    && !featureFlags['is-zip-override-fallback-enabled']) && !gptSkipCalendarVariantFlowEnabled
                                && !isStandAloneMovieSku
                                && (
                                    <div>
                                        {!isAuthenticated && (
                                            <div
                                                className={featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar ? classes.paperHeaderLinkV2 : classes.paperHeaderLink}
                                                role="button"
                                                tabIndex={-1}
                                                onKeyDown={() => { }}
                                                onClick={async () => {
                                                    trackEvent({
                                                        eventCategory: 'Sign In', eventAction: 'Login', eventLabel: 'Logon_From_Normal|<<pageType>>',
                                                    });

                                                    await auth.loginByRedirect();
                                                }}
                                                data-test="pdp-address-book"
                                                id="address-book-signin"
                                                name="pdpSignin"
                                            >
                                                {isPdpDeliveryTopEnabled || isPlaRedesignEnabled ? 'Sign In For Contacts' : 'Sign in to access your contacts'}
                                            </div>
                                        )}
                                        {isAuthenticated && isWriteScopeCheckout && (
                                            <AddressBookWithPagination
                                                name="pdpAddressBook"
                                                entries={addressBookEntries}
                                                onSelectedAddress={this.handleSelectedAddressBook}
                                                loadAddressBook={callLoadAddressBook}
                                                handleRemoveAddressBook={this.handleRemoveAddressBook}
                                                handleChangeAddressBook={() => { }}
                                                pageOn={addressBookPageOn}
                                                noOfPages={addressBookTotalPages}
                                                totalAddresses={totalAddresses}
                                                isAccessBasedOnScopeEnabled={isAccessBasedOnScopeEnabled}
                                                pageType="pdp"
                                                isPdpRedesignEnabled={isPdpRedesignEnabled}
                                                isCCONewCalenadarEnabled={featureFlags['is-new-delivery-calendar-enabled']}
                                                displayDeliveryCalendar={displayDeliveryCalendar}
                                                isPdpDeliveryTopEnabled={isPdpDeliveryTopEnabled}
                                                isPdpRedesignShortEnabled={isPdpRedesignShortEnabled}
                                                isPlaRedesignEnabled={isPlaRedesignEnabled}
                                            />
                                        )}
                                        {isAuthenticated && !isWriteScopeCheckout && <LimitedAccessReSignInLink />}
                                    </div>
                                )
                            }
                        </div>
                    )}
                    <div className={classes.paperBody}>
                        <form noValidate autoComplete="off">
                            { /* avoid displaying zipcode and location type fields for international products */}
                            {!isInternationalProduct && showDeliveryField && (displayDeliveryCalendar && !featureFlags['is-zip-override-fallback-enabled']) && !gptSkipCalendarVariantFlowEnabled && (
                                <>
                                    <div className={classes.formContainer}>
                                        <div className={featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar ? classes.formWrapperV2 : classes.formWrapper}>
                                            <DesktopMobile
                                                desktop={() => (
                                                    <>
                                                        <TextField
                                                            className={this.displayZipValidCSSCheck(isInternationalProduct, internationalCountry)}
                                                            style={{ border: featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar ? '1px solid #C4C4C4' : '', borderRadius: featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar ? '3px' : '' }}
                                                            margin="normal"
                                                            id="add-zipcode-text-field"
                                                            data-test="pdp-zipcode-text-field"
                                                            data-testid="pdp-zipcode-text-field"
                                                            name="zipcodeTextField"
                                                            label={featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar ? 'Zip Code*' : (deliveryData.zip_code_title || 'Delivery Zip Code*')}
                                                            onKeyPress={this.handleZipFieldKeyPress}
                                                            onChange={this.handleZipChange}
                                                            // defaultValue={userSubmittedZip}
                                                            value={zipField || validatedZip}
                                                            inputRef={this.zipFieldRef}
                                                            InputProps={(featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar) || isPdpRedesignEnabled ? { disableUnderline: true } : { disableUnderline: false }}
                                                        />
                                                        {featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar && this.renderZipVerificationSvg()}
                                                    </>
                                                )}
                                                mobile={() => (
                                                    <>
                                                        <TextField
                                                            variant={isPdpRedesignEnabled ? 'outlined' : 'standard'}
                                                            error={!!(!zipField && fireCalendarQuery)}
                                                            className={this.displayZipValidCSSCheck(isInternationalProduct, internationalCountry)}
                                                            margin="normal"
                                                            id="add-zipcode-text-field"
                                                            data-test="pdp-zipcode-text-field"
                                                            data-testid="pdp-zipcode-text-field"
                                                            name="zipcodeTextField"
                                                            label={((featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar) || isPdpDeliveryTopEnabled) ? (`${isPdpDeliveryTopEnabled ? 'ZIP Code*' : 'Zip Code*'}`) : deliveryData.zip_code_title || 'Delivery Zip Code*'}
                                                            onKeyPress={this.handleZipFieldKeyPress}
                                                            onChange={this.handleZipChange}
                                                            type={isCanadian ? 'text' : 'tel'}
                                                            value={zipField || validatedZip}
                                                            inputRef={this.zipFieldRef}
                                                            InputProps={featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar ? { disableUnderline: true } : { disableUnderline: false }}
                                                        />
                                                        {featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar && this.renderZipVerificationSvg()}
                                                    </>
                                                )}
                                            />
                                        </div>
                                        {
                                            isPdpRedesignEnabled
                                                ? (
                                                    <FormControl className={classes.locationForm} role="region" aria-label="SelectLocation" variant="outlined">
                                                        <InputLabel
                                                            className={`${classes.locationTypeLabel} ${classes.selectLabel}`}
                                                            htmlFor="location-type"
                                                        >
                                                            {isPdpDeliveryTopEnabled ? 'Location*' : ' Location Type*'}
                                                        </InputLabel>
                                                        <NativeSelect
                                                            defaultValue=""
                                                            className={`${classes.locationSelect}`}
                                                            value={locationType}
                                                            data-testid="pdp-frequency-type"
                                                            disableUnderline
                                                            onChange={this.handleLocationTypeChange}
                                                            inputProps={{
                                                                name: 'location-type',
                                                                id: 'location-type',
                                                                'aria-hidden': 'true',
                                                                tabIndex: '-1',
                                                            }}
                                                        >
                                                            {featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar && foodBrandLocationTypeOptions.map((location) => (
                                                                <option aria-hidden="true" value={location}>{location}</option>

                                                            ))}
                                                            {!featureFlags['is-new-delivery-calendar-enabled'] && displayFlowersLocationNewTypes()}
                                                        </NativeSelect>
                                                    </FormControl>
                                                )
                                                : (
                                                    selectInput()
                                                )
                                        }
                                    </div>
                                    {isDeliveryDateOptionsEnabled && this.deliveryDateOptionButtons(isInternationalProduct, internationalCountry)}
                                    {featureFlags['is-card-isle-pdp-add-on'] && cardIsleEnabled && !isPmallCardIsleFlow && <LoadCardIslePDP />}
                                </>
                            )}
                            {variantAddon && isDeliveryDateOptionsEnabled && (
                                <div className={classes.addonWrapper}>
                                    {((zipValid === true && zipField.length >= 5 && isDeliveryEnabed && addonDateSelected) || (userSubmittedZip !== '' && zipField === userSubmittedZip && isDeliveryEnabed && addonDateSelected)) ? (
                                        <PDPAddonContainer
                                            productCode={selectedSku?.id}
                                            productBaseCode={partNumber}
                                            zipCode={zipField || validatedZip}
                                            selectedDate={productIsNotAvailable ? startDate : (addonDateSelected || deliveryDateOption)}
                                            categoryId={categoryId}
                                            pdpContent={content}
                                            isZipInVaild={zipValid === false || zipField.length < 5 || !deliveryDateOption?.trim()}
                                            isProductNotAvailable={productIsNotAvailable && zipField.length >= 5}
                                        />
                                    ) : (
                                        <PDPAddonMessage
                                            pdpContent={content}
                                            isZipInVaild={zipValid === false || zipField.length < 5 || !deliveryDateOption?.trim()}
                                            isProductNotAvailable={productIsNotAvailable && zipField.length >= 5}
                                        />
                                    )}
                                </div>
                            )}
                            {isVaseConfiguratorProduct && !validVaseConfiguratorSku
                                && <VaseConfigATCError />}
                            {showAddToCart && <AddToCarErrorInline />}
                            {showAddToCart && (
                                <DeliveryCalendarButtonContainer
                                    addTodayOrTomToCart={this.addTodayOrTomToCart}
                                    fullCalendarCall={() => {
                                        this.handleAgeVerify(handleMobileAgeVerification, hasWine);
                                    }}
                                    zipValid={zipValid}
                                    productDeliveryType={productDeliveryType}
                                    isInternationalProduct={isInternationalProduct}
                                    todayTomorrowFlagEnabled={featureFlags['is-today-tomorrow-enabled']}
                                    displayDeliveryCalendar={(displayDeliveryCalendar && !featureFlags['is-zip-override-fallback-enabled'] && !gptSkipCalendarVariantFlowEnabled)}
                                    pmallAddToCartDisabled={isPmallProduct && !pmallSummaryInfo?.customizations?.refnum}
                                    vaseConfiguratorDisabled={isVaseConfiguratorProduct && !validVaseConfiguratorSku}
                                    trackEvent={trackEvent}
                                    isGPTCalendarButtonTextTestActive={isGPTCalendarButtonTextTestActive}
                                    presentationFamily={presentationFamily}
                                    deliveryCalendarEnable={featureFlags['is-new-delivery-calendar-enabled']}
                                    brandId={brandId}
                                    isPdpRedesignEnabled={isPdpRedesignEnabled}
                                    addToCartButtonRedesign={addToCartButtonRedesign}
                                    selectedSku={selectedSku}
                                    deliveryDateOptionsFlagEnabled={featureFlags['is-delivery-date-options-on-pdp-ab-test-enabled']}
                                    deliveryDateOption={deliveryDateOption}
                                    variantDeliveryOptions={variantDeliveryOptions}
                                    dateSelectedFromCalendar={dateSelectedFromCalendar}
                                    deliveryDateOptionsFlexDetails={deliveryDateOptionsFlexDetails}
                                    flexTodayTomorrowAddToCart={this.flexTodayTomorrowAddToCart}
                                    updatePersonalizationState={this.updatePersonalizationState}
                                    personalizationAdded={personalizationAdded}
                                    flexDetailsAvailable={flexDetailsAvailable}
                                    locationType={locationType}
                                    addToCartPriceShow={addToCartPriceShow}
                                    isCaDelivery={isCaDelivery}
                                    isDeliverCharges={isDeliverCharges}
                                    zipField={zipField}
                                    addToCartPrice={totalAddtoCartPrice}
                                    addonVariant={variantAddon && isDeliveryDateOptionsEnabled}
                                    stickyAtcEnabled={stickyAtcEnabled}
                                    stickyAtcRequiresSavedZip={stickyAtcRequiresSavedZip}
                                    isZipSavedForStickyAtc={isZipSavedForStickyAtc}
                                />
                            )}
                            {isTalonOneCreditWidgetEnabled && <TalonOneBanner user={user} firstName={user?.firstName} pageType={pageType} />}
                            {isPdpRedesignEnabled && showAddToCart && <div><KlarnaCreditPromotionBadge selectedSku={selectedSku} /></div>}
                            {!isVaseConfiguratorProduct && (
                                <OneClickPaymentBuilder
                                    selectedSku={selectedSku}
                                    movieSelected={movieSelected}
                                    isStandAloneMovieSku={isStandAloneMovieSku}
                                    productCategories={productCategories}
                                />
                            )}
                            {fireCalendarQuery && (
                                <GraphqlCalendarContainer
                                    close={this.closeCalendar}
                                    isOpen={showCalendar}
                                    selectedItemId={selectedSku?.id}
                                    selectedSku={selectedSku}
                                    productDeliveryType={productDeliveryType}
                                    productName={productName}
                                    brandId={brandId}
                                    ageDetails={ageDetails}
                                    setCalendarDataLoadingFlag={
                                        this.setCalendarDataLoadingFlag
                                    }
                                    handleDeliveryAvailability={
                                        this.handleDeliveryAvailability
                                    }
                                    partNumber={partNumber}
                                    todayTomDateNotAvailText={todayTomDateNotAvailText}
                                    isInternationalProduct={isInternationalProduct}
                                    internationalCountry={internationalCountry}
                                    isPassportBundleItem={isPassportBundleItem}
                                    validatedZip={validatedZip}
                                    personalization={personalization}
                                    movieSelected={movieSelected}
                                    isPassportBundleProduct={isPassportBundleProduct || {}}
                                    hasWine={selectedSku?.ageVerifyFlag}
                                    isFlowersSubscriptionFeatureEnabled={isFlowersSubscriptionFeatureEnabled}
                                    isFlowersTempV1SubscriptionFeatureEnabled={isFlowersTempV1SubscriptionFeatureEnabled}
                                    subscription={subscription}
                                    subscriptionDetails={subscriptionDetails}
                                    handleMiniCartModalClick={handleMiniCartModalClick}
                                    enableMinicart={enableMinicart}
                                    showWrapup={showWrapup}
                                    productSkus={productSkus}
                                    displayDeliveryCalendar={displayDeliveryCalendar}
                                    isPersistAddressEnabled={isPersistAddressEnabled}
                                    handlePickADate={this.handlePickADate}
                                    isDeliveryDateOptionsEnabled={isDeliveryDateOptionsEnabled}
                                    deliveryDateOption={deliveryDateOption}
                                />
                            )}
                            {showAgeVerification
                                && (
                                    <ConnectedProductAgeVerificationModal
                                        isOpen={showAgeVerification}
                                        setCalendarDataLoadingFlag={
                                            this.setCalendarDataLoadingFlag
                                        }
                                        handleAgeVerificationClose={
                                            this.handleAgeVerificationClose
                                        }
                                        getAgeVerificationDetails={
                                            this.getAgeVerificationDetails
                                        }
                                    />
                                )}
                        </form>
                    </div>
                </Paper>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locationType: getLocationType(state),
    brand: getBrand(state),
    validatedZip: getValidatedZipcode(state),
    zipValid: getIsProductFilterZipcodeValid(state),
    userSubmittedZip: getUserSubmittedProductFilterZipcode(state),
    isAuthenticated: getIsAuthenticatedStatus(state),
    savedAddress: getSavedAddress(state),
    addressBookEntries: getAddressBookEntries(state),
    addressBookPageOn: getAddressBookPageNumber(state),
    addressBookTotalPages: getTotalNoOfPages(state),
    totalAddresses: getTotalEntriesAddressBook(state),
    userType: getUserType(state),
    // featureFlags: getFeatureFlags(state), will get from prop from parent comp
    wineValidation: getWineData(state),
    passportInCart: getPassportSubscriptionStatus(state),
    isPassportUser: getIsPassportUserLoggedIn(state),
    activeABTests: getActiveABTests(state),
    // presentationFamily: getPresentationFamily(state), will get from prop from parent comp
    isWriteScopeCheckout: getIsWriteScopeCheckout(state),
    isAccessBasedOnScopeEnabled: getFeatureFlag('is-access-based-on-scope-enabled')(state),
    subscriptionValues: getSubscriptionFrequencyData(state),
    deviceType: getSSRDeviceType(state),
    pageType: getPageType(state),
    user: getProfileInfo(state),
});

const mapDispatchToProps = (dispatch) => ({
    setLocation: bindActionCreators(setLocationType, dispatch),
    // this is the same as: resetFilterZipcodeValidity
    resetZipValidity: bindActionCreators(
        resetProductFilterZipcodeValidity,
        dispatch,
    ),
    setZipcodeValidity: bindActionCreators(setProductFilterZipcodeValidity, dispatch),
    valZip: bindActionCreators(validateProductFilterZipcode, dispatch),
    clearValidatedZip: bindActionCreators(clearValidatedZipcode, dispatch),
    setFilterZip: bindActionCreators(
        setUserSubmittedProductFilterZipcode,
        dispatch,
    ),
    setValZip: bindActionCreators(setValidatedZipcode, dispatch),
    clearFilterZip: bindActionCreators(clearUserSubmittedProductFilterZipcode, dispatch),
    // this is the same as resetFilterZipcodeValidity
    resetFilterZipcodeValidity: bindActionCreators(resetProductFilterZipcodeValidity, dispatch),
    clearSavedAddress: bindActionCreators(clearUserSelectedAddress, dispatch),
    actionAddToCart: bindActionCreators(addToCartNewCartServices, dispatch),
    callLoadAddressBook: bindActionCreators(loadAddressBook, dispatch),
    callRemoveAddressBook: bindActionCreators(removeAddressBook, dispatch),
    setSelectedAddress: bindActionCreators(setUserSelectedAddress, dispatch),
    trackEvent: bindActionCreators(tagManagerActions.trackEvent, dispatch),
    queueEvent: bindActionCreators(tagManagerActions.queueEvent, dispatch),
    callVerifyWine: bindActionCreators(verifyWine, dispatch),
    dispatchEmitCustomTrackingEvent: bindActionCreators(emitCustomTrackingEvent, dispatch),
});

GraphqlAddToCartContainerUI.propTypes = {
    auth: shape({
        loginByRedirect: func.isRequired,
        getAccessTokenSafely: func.isRequired,
    }).isRequired,
    classes: object.isRequired,
    locationType: string.isRequired,
    validatedZip: string.isRequired,
    zipValid: bool,
    setLocation: func.isRequired,
    resetZipValidity: func.isRequired,
    brand: object.isRequired,
    valZip: func.isRequired,
    clearValidatedZip: func.isRequired,
    userSubmittedZip: string.isRequired,
    setValZip: func.isRequired,
    selectedSku: shape({
        __typename: string.isRequired,
        id: string.isRequired,
        name: string.isRequired,
    }),
    setFilterZip: func.isRequired,
    productDeliveryType: string.isRequired,
    passportInCart: bool,
    productCategories: array.isRequired,
    productSkus: arrayOf(
        shape({
            id: string.isRequired,
            name: string.isRequired,
            ageVerifyFlag: string.isRequired,
            minAge: string.isRequired,
            prices: arrayOf(
                shape({
                    type: string.isRequired,
                    value: number.isRequired,
                }),
            ),
            isInternational: bool.isRequired,
        }),
    ).isRequired,
    brandId: string.isRequired,
    deliveryData: shape({
        location_type_options: arrayOf(
            shape({
                name: string.isRequired,
                value: string,
            }),
        ),
        show: bool.isRequired,
        title: string.isRequired,
        zip_code_title: string.isRequired,
        location_type_title: string.isRequired,
    }).isRequired,
    isAuthenticated: bool.isRequired,
    clearFilterZip: func.isRequired,
    clearSavedAddress: func.isRequired,
    setZipcodeValidity: func.isRequired,
    savedAddress: shape({
        addressSource: string,
        addressComponents: arrayOf(
            shape({ // This shape is for addresses saved from google places. More will be added when aditional address sources are added
                long_name: string.isRequired,
                short_name: string.isRequired,
                types: arrayOf(
                    string,
                ).isRequired,
            }),
        ),
    }).isRequired,
    isPassportUser: bool,
    partNumber: string.isRequired,
    actionAddToCart: func.isRequired,
    history: object.isRequired,
    location: object.isRequired,
    resetFilterZipcodeValidity: func.isRequired,
    callLoadAddressBook: func.isRequired,
    userType: string.isRequired,
    callRemoveAddressBook: func.isRequired,
    setSelectedAddress: func.isRequired,
    addressBookEntries: array.isRequired,
    addressBookPageOn: number.isRequired,
    addressBookTotalPages: number.isRequired,
    totalAddresses: number.isRequired,
    trackEvent: func.isRequired,
    productName: string.isRequired,
    featureFlags: object.isRequired,
    flags: object.isRequired,
    isPassportBundleItem: bool.isRequired,
    displayDeliveryCalendar: bool.isRequired,
    movieSelected: shape({
        error: bool,
        skuSelected: shape({
            sku: string.isRequired,
            sku_description: string.isRequired,
            sku_price: number.isRequired,
        }),
    }),
    isPassportBundleProduct: shape({
        prices: {
            value: number,
        },
        enable: bool,
    }),
    categoryId: string,
    categoryPath: string,
    categoryName: string,
    handleMobileAgeVerification: func,
    hasWine: bool,
    callVerifyWine: func.isRequired,
    wineValidation: shape({
        wineAvailability: object, // object type array
        wineVerify: shape({
            birthDay: 'string',
            birthMonth: 'string',
            birthYear: 'string',
            minAge: 'string',
        }),
    }),
    isFlowersSubscriptionFeatureEnabled: bool.isRequired,
    isFlowersTempV1SubscriptionFeatureEnabled: bool.isRequired,
    subscriptionDetails: shape({
        subscriptionType: string,
        subscriptionDuration: string,
        subscriptionFrequency: string,
    }),
    subscriptionValues: shape({
        duration: string,
        subscriptionType: string,
    }),
    subscription: shape({
        subscriptionKey: array,
        subscriptionIndefinite: string,
        subscriptionType: array,
        implementProductSubscription: bool,
        viewSubscription: bool,
        isTypeDiscovery: bool,
    }),
    handleMiniCartModalClick: func.isRequired,
    enableMinicart: bool.isRequired,
    productNotAvailable: shape({
        product_not_available_text: string.isRequired,
        cta_text: string.isRequired,
    }),
    isStandAloneMovieSku: bool,
    pmallSummaryInfo: shape({
        customizations: arrayOf(
            shape({
                refnum: string,
                description: string,
                'preview-url': string,
            }),
        ),
    }).isRequired,
    activeABTests: object,
    validVaseConfiguratorSku: bool.isRequired,
    presentationFamily: string,
    showWrapup: string,
    isWriteScopeCheckout: bool.isRequired,
    isAccessBasedOnScopeEnabled: bool.isRequired,
    device: string.isRequired,
    isPlaPage: bool,
    content: object,
    isPdpRedesignEnabled: bool,
    showAddToCart: bool,
    showDeliveryField: bool,
    showProductTitleTop: bool,
    isPdpRedesignShortEnabled: bool,
    addToCartButtonRedesign: bool,
    isPlaRedesignEnabled: bool,
    isPersistAddressEnabled: bool,
    variantDeliveryOptions: bool.isRequired,
    variantAddon: bool,
    selectAddons: array,
    addToCartPriceShow: object,
    isCaDelivery: bool,
    isDeliverCharges: bool,
    addToCartPrice: number,
    stickyAtcEnabled: bool,
    stickyAtcRequiresSavedZip: bool,
    pageType: string,
    user: object,
    dispatchEmitCustomTrackingEvent: func.isRequired,
};

GraphqlAddToCartContainerUI.defaultProps = {
    zipValid: null,
    selectedSku: null,
    movieSelected: null,
    isPassportBundleProduct: {},
    categoryId: '',
    categoryPath: '',
    categoryName: '',
    handleMobileAgeVerification: () => { },
    hasWine: false,
    wineValidation: null,
    subscriptionDetails: {},
    subscriptionValues: {},
    subscription: {},
    productNotAvailable: {},
    isStandAloneMovieSku: false,
    passportInCart: false,
    isPassportUser: false,
    activeABTests: {},
    presentationFamily: '',
    showWrapup: 'true',
    isPlaPage: false,
    content: {},
    isPdpRedesignEnabled: false,
    showAddToCart: true,
    showDeliveryField: true,
    showProductTitleTop: false,
    isPdpRedesignShortEnabled: false,
    addToCartButtonRedesign: false,
    isPlaRedesignEnabled: false,
    isPersistAddressEnabled: false,
    variantAddon: false,
    selectAddons: [],
    addToCartPriceShow: null,
    isCaDelivery: false,
    isDeliverCharges: false,
    addToCartPrice: '',
    stickyAtcEnabled: false,
    stickyAtcRequiresSavedZip: false,
    pageType: '',
    user: {},
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withRouter,
    withAuth,
    withStyles(styles),
)(GraphqlAddToCartContainerUI);
